<template>
	<div>
        <contentCard :loading="loading">
            <template slot="cardContent">
                <div>
                    <v-row align="center" justify="space-between">
                        <v-col cols="12" md="9" class="">
                            <v-row class="" justify="start" no-gutters>
                                <!-- <v-col cols="1"> -->
                                    <alternativeButton
                                        ref="returnbtn"
                                        :props="returnBtnData"
                                    ></alternativeButton>
                                <!-- </v-col> -->
                                <v-col class="ml-2 " align-self="center">
                                    <p class="mb-0 font-weight-bold text-col">{{employeeInfo}}</p>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-spacer></v-spacer>

                    </v-row>
                    <v-row>
                        <v-col>
                            <v-tabs
                                v-model="tab"
                                centered
                                :show-arrows="true"
                                grow
                                active-class="font-weight-bold tab-active"
                                >
                                <v-tabs-slider></v-tabs-slider>

                                <v-tab href="#1"  :class="`tab-header  `" >
                                    Generales
                                </v-tab>

                                <v-tab href="#6" :class="`tab-header  `" v-permission:unless="'integradora_user.show'">
                                    Puesto
                                </v-tab>

                                <v-tab href="#7"  :class="`tab-header  `" >
                                    Docs. Alta
                                </v-tab>

                                <v-tab href="#8"  :class="`tab-header  `" v-if="showCutBack"  v-permission:unless="'integradora_user.show'">
                                    Docs. Baja
                                </v-tab>


                                <v-tab href="#11" :class="`tab-header  `"  v-permission:unless="'integradora_user.show'">
                                    Asistencias
                                </v-tab>


                                <v-tab href="#10"  :class="`tab-header  `" v-if="showCutBack"  v-permission:unless="'integradora_user.show'">
                                    Encuesta de salida
                                </v-tab>

                                <v-tab href="#5" :class="`tab-header  `" v-permission="'vacations.show'"  >
                                    Vacaciones
                                </v-tab>

                                <v-tab href="#9" :class="`tab-header  `"  v-permission:unless="'integradora_user.show'">
                                    Recibos
                                </v-tab>

                                <v-tab href="#4" :class="`tab-header  `"  v-permission:unless="'integradora_user.show'">
                                    Patrimonio
                                </v-tab>


                                <!-- <v-tab href="#2"  :class="`tab-header  `"  v-permission:unless="'integradora_user.show'">
                                    Eventualidades
                                </v-tab> -->

                                <v-tab href="#3" :class="`tab-header  `"  v-permission:unless="'integradora_user.show'">
                                    Cuestionarios
                                </v-tab>





                            </v-tabs>


                            <v-tabs-items v-model="tab">

                                <!-- GENERALES -->
                                <v-tab-item
                                    value="1"
                                >

                                    <v-row justify="center">

                                        <v-col cols="12" :lg="7"  >
                                            <v-row justify="center" class="mt-5" v-if="$vuetify.breakpoint.mdAndDown" v-permission:unless="'integradora_user.show'">
                                                <v-col cols="12" class="text-center-web" >
                                                    <v-img


                                                    max-width="250"
                                                    :src="img"
                                                ></v-img>
                                                </v-col>

                                                <v-col cols="12" class="max-width-statics-btn">
                                                    <primary-button :props="exportBtnData"></primary-button>
                                                </v-col>
                                            </v-row>

                                            <separator title="PERSONALES"></separator>
                                            <details-item :detailsItems="generalPersonal"></details-item>

                                            <div v-permission:unless="'integradora_user.show'">
                                                <separator title="BENEFICIARIOS"></separator>
                                                <details-item :detailsItems="generalpayee"></details-item>

                                            </div>

                                            <div v-permission:unless="'integradora_user.show'">

                                                <separator title="HIJOS/HIJAS"></separator>
                                                <details-item :detailsItems="generalChildren.info"></details-item>
                                                <details-item :class="index == 0 ? '': 'mt-5'" v-for="(items, index) in generalChildren.children" :key="index" :detailsItems="items"></details-item>

                                            </div>

                                            <div v-permission:unless="'integradora_user.show'">

                                                <separator title="CONTRATACIÓN"></separator>
                                                <details-item :detailsItems="generalContract"></details-item>
                                            </div>

                                            

                                            <!-- FILES -->
                                            <v-row justify="center" no-gutters v-permission:unless="'integradora_user.show'">
                                                <v-col class="my-0 py-0">
                                                    <!-- <div v-for="(item, j) in detailsItems" :key="j"> -->
                                                        <v-row justify="center" align="center" no-gutters class="my-2">
                                                            <v-col align-self="start" ><span class="font-weight-bold normalText--text">PDF de contratos</span></v-col>
                                                            <!-- <v-col class="text-right">
                                                                <a target="_blank" :href="''"><v-icon  color="secondary" >mdi-open-in-new</v-icon></a>
                                                            </v-col> -->
                                                        </v-row>
                                                        <!-- <v-divider></v-divider> -->
                                                    <!-- </div> -->
                                                    <div v-for="(item, j) in files" :key="j">
                                                        <v-row justify="center" align="center" no-gutters class="my-2">
                                                            <v-col align-self="start" ><span class=" normalText--text">{{item.name}}</span></v-col>
                                                            <v-col class="text-right">
                                                                <a target="_blank" :href="item.url"><v-icon  color="secondary" >mdi-open-in-new</v-icon></a>
                                                            </v-col>
                                                        </v-row>
                                                        <!-- <v-divider></v-divider> -->
                                                    </div>
                                                </v-col>
                                            </v-row>


                                            <div v-permission:unless="'integradora_user.show'">
                                                <separator title="Nómina"></separator>
                                                <details-item :detailsItems="generalSalary"></details-item>
                                            </div>

                                        </v-col>
                                        <v-col  v-permission:unless="'integradora_user.show'">
                                        <v-row justify="center" class="mt-5" v-if="$vuetify.breakpoint.lgAndUp">
                                                <v-col cols="12" class="text-center-web" >
                                                    <v-img


                                                    max-width="250"
                                                    :src="img"
                                                ></v-img>
                                                </v-col>

                                                <v-col cols="12" class="max-width-statics-btn">
                                                    <primary-button :props="exportBtnData"></primary-button>
                                                </v-col>
                                        </v-row>
                                        </v-col>

                                    </v-row>
                                </v-tab-item>



                                <!-- ASISTENCIAS -->
                                <v-tab-item
                                    value="11"
                                >

                                    <v-row>
                                        <v-col>
                                            <StatisticAssistenceCalendar :employeeId="id" :isActive="!showCutBack"/>
                                        </v-col>
                                    </v-row>
                                </v-tab-item>


                                <!-- EVENTUALIDADES -->
                                <v-tab-item
                                    value="2"
                                >

                                    <v-row>
                                        <v-col>
                                            <datatable :props="tableProps" @method_handler="method_handler">
                                            </datatable>
                                        </v-col>
                                    </v-row>
                                </v-tab-item>

                                <!-- CUESTIONARIOS -->
                                <v-tab-item
                                    value="3"
                                >
                                    <div class="mt-2">
                                        <v-row class="my-0 mx-1" v-if="qList.length == 0 && !loadingQuestionaries">
                                            <v-col class="py-2">
                                                <p class="text-center">Sin información</p>
                                            </v-col>
                                        </v-row>
                                        <v-row class="my-0 mx-1" v-if="loadingQuestionaries">
                                            <v-col class="py-2 text-center">
                                                <v-progress-circular
                                                indeterminate
                                                color="primary"
                                                ></v-progress-circular>
                                            </v-col>
                                        </v-row>
                                        <template v-if="!loadingQuestionaries">
                                            <v-row class="my-0 mx-1" v-for="q in qList" v-bind:key="q.id" >
                                                <v-col class="py-2">
                                                    <v-card width="100%" elevation="3" min-height="20">
                                                        <v-card-text>
                                                            <v-row justify="space-between">
                                                                <v-col class="py-2">
                                                                    <p class="mb-0 pb-0">{{q.text}}</p>
                                                                </v-col>

                                                                <v-col align-self="center" class="p-6">
                                                                    <v-row justify="end" class="mr-1">
                                                                        <v-chip
                                                                            color="success"
                                                                            value=""
                                                                        >
                                                                            {{q.status}}
                                                                        </v-chip>
                                                                    </v-row>
                                                                </v-col>
                                                            </v-row>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-col>
                                            </v-row>
                                        </template>

                                    </div>
                                </v-tab-item>


                                <!-- PATRIMONIO -->
                                <v-tab-item value="4">
                                    <v-row>
                                        <v-col>
                                            <datatable :props="tableAssignProps" @method_handler="method_handler">
                                            </datatable>
                                        </v-col>
                                    </v-row>
                                </v-tab-item>


                                <!-- Vacaciones -->
                                <v-tab-item value="5">
                                    <v-row>
                                        <v-col>
                                            <datatable :props="tableVacations" @method_handler="method_handler">
                                            </datatable>
                                        </v-col>
                                    </v-row>
                                </v-tab-item>

                                <!-- payrolls -->
                                <v-tab-item value="9">

                                    <div class="mt-2">

                                        <v-row class="my-0 mx-1" v-if="loadingPayrolls">
                                            <v-col class="py-2 text-center">
                                                <v-progress-circular
                                                indeterminate
                                                color="primary"
                                                ></v-progress-circular>
                                            </v-col>
                                        </v-row>
                                        <template v-else>
                                            <v-row>
                                                <v-col>
                                                    <v-row>
                                                        <v-col cols="12" md="2" lg="1" xl="1">
                                                             <alternativeAutocompleteOne
                                                                class=""
                                                                :items="years"
                                                                :valueInput="selectedYearPayrolls"


                                                                @valueChange="(v) => {selectedYearPayrolls = v; loadPayrollDates()}"
                                                                @onChange="(v) => {}"

                                                                :label="'Año'"
                                                                classesContainer="width-auto"
                                                            ></alternativeAutocompleteOne>
                                                        </v-col>
                                                    </v-row>


                                                    <v-row>
                                                        <v-col v-for="(item, index) in datesPayload" :key="index" :class="`px-0 ${index == 0 ? 'pl-3':''} ${index == 3 ? 'pr-4':''} `">
                                                           <div class="mx-0">
                                                                <div class="statistic-payroll-header">
                                                                    <p class="pb-0 ">Trimestre {{item.quarter}}</p>
                                                                </div>

                                                                <v-card elevation="3" height="40" color="" class="mx-2 my-2 py-0 statistic-payroll-card" v-for="(dateP, indexP) in item.dates" :key="indexP">
                                                                    <v-card-text class="py-0 statistic-payroll-card-text-cont">
                                                                        {{ut.globalDateFormat(dateP.dateStart)}} - {{ut.globalDateFormat(dateP.dateEnd)}}
                                                                        <div>
                                                                            <v-icon @click="openPay(dateP.fFileUrl)" :color="dateP.fFileUrl == '' ? 'gray':'success'" class=" mr-2" size="21">mdi-file-document-outline</v-icon>
                                                                            <v-icon @click="openPay(dateP.iFileUrl)" :color="dateP.iFileUrl == '' ? 'gray':'blue'" class="" size="21">mdi-file-document-outline</v-icon>
                                                                        </div>
                                                                    </v-card-text>
                                                                </v-card>
                                                           </div>

                                                        </v-col>
                                                    </v-row>


                                                </v-col>
                                            </v-row>
                                        </template>

                                    </div>
                                </v-tab-item>


                                <!-- Position -->
                                <v-tab-item value="6">

                                    <div class="mt-2">

                                        <v-row class="my-0 mx-1" v-if="loadingPosition">
                                            <v-col class="py-2 text-center">
                                                <v-progress-circular
                                                indeterminate
                                                color="primary"
                                                ></v-progress-circular>
                                            </v-col>
                                        </v-row>
                                        <template v-if="!loadingPosition">
                                            <v-row>
                                                <v-col>
                                                    <details-item :detailsItems="positionItems"></details-item>
                                                </v-col>
                                            </v-row>
                                        </template>

                                    </div>
                                </v-tab-item>

                                <!-- Docs. Alta -->
                                <v-tab-item value="7">
                                    <v-row v-permission:unless="'integradora_user.show'">
                                        <v-col class="text-left ml-4">
                                            <div class=" body-1 mb-2">
                                                <span class="font-weight-bold">Documentos Base</span> ({{docTotalsString}})
                                            </div>
                                            <v-progress-linear background-color="inputsBackground" :indeterminate="loadingUpdate" :value=" loadingUpdate ? '0': percReqDoc" color="success" height="10"></v-progress-linear>
                                        </v-col>

                                    </v-row>


                                    <div v-permission:any="'integradora_user.show'">
                                        <v-row justify="center">
                                            <v-col cols="12" md="6">
                                                <details-item :detailsItems="externalUserDocuments"></details-item>
                                            </v-col>
                                        </v-row>
                                    </div>


                                    <v-form ref="form" @submit.prevent="update" class="mt-4" v-permission:unless="'integradora_user.show'">
                                        <v-row justify="center">

                                            <v-col cols="12" md="6">
                                                <div class="d-flex">
                                                    <checkboxForm
                                                        v-if="form.birthCertificate_showRequired"
                                                        label=""
                                                        :valueInput="form.birthCertificate_required"
                                                        :rule="[]"
                                                        :disabled="loadingUpdate"
                                                        @valueChange="(v) => {form.birthCertificate_required = (v == true ? 1:0); this.update()}"
                                                        class="mx-3 documents-check"
                                                    ></checkboxForm>
                                                    <fileInputForm
                                                        name="p2"
                                                        label="Acta de nacimiento"
                                                        :multiple="false"
                                                        :valueInput="form.birthCertificate_file"
                                                        :url="form.birthCertificate_url"
                                                        :showDelete="form.birthCertificate_showDelete"
                                                        :rule="[]"
                                                        :disabled="form.birthCertificate_showDelete == false ? true : loadingUpdate"
                                                        @cleared:file="(v) => { this.openDeleteDocument('birthCertificate_url')}"
                                                        @valueChange="(v) => {form.birthCertificate_file = v; delete serverErrors[`documentation.ACTA DE NACIMIENTO`]; this.update()}"
                                                        :errorMessages="serverErrors[`documentation.ACTA DE NACIMIENTO`]"

                                                        class="width-available"
                                                    ></fileInputForm>
                                                </div>

                                            </v-col>

                                            <v-col  v-permission:unless="'integradora_user.show'">
                                                <div class="d-flex">
                                                    <checkboxForm
                                                        v-if="form.recomendationLetter_showRequired"
                                                        label=""
                                                        :valueInput="form.recomendationLetter_required"
                                                        :rule="[]"
                                                        :disabled="loadingUpdate"
                                                        @valueChange="(v) => {form.recomendationLetter_required = (v == true ? 1:0); this.update()}"
                                                        class="mx-3 documents-check"
                                                    ></checkboxForm>
                                                    <fileInputForm
                                                        name="p2"
                                                        label="Carta de recomendación"
                                                        :multiple="false"
                                                        :valueInput="form.recomendationLetter_file"
                                                        :url="form.recomendationLetter_url"
                                                        :rule="[]"
                                                        :disabled="form.recomendationLetter_showDelete == false ? true : loadingUpdate"
                                                        :showDelete="form.recomendationLetter_showDelete"
                                                        @cleared:file="(v) => { this.openDeleteDocument('recomendationLetter_url')}"
                                                        @valueChange="(v) => {form.recomendationLetter_file = v; delete serverErrors[`documentation.CARTA DE RECOMENDACIÓN`]; this.update()}"
                                                        :errorMessages="serverErrors[`documentation.CARTA DE RECOMENDACIÓN`]"
                                                        class="width-available"
                                                    ></fileInputForm>
                                                </div>
                                            </v-col>
                                        </v-row>


                                        <v-row justify="center">
                                            <v-col cols="12" md="6">
                                                <div class="d-flex">
                                                    <checkboxForm
                                                        v-if="form.ine_showRequired"
                                                        label=""
                                                        :valueInput="form.ine_required"
                                                        :rule="[]"
                                                        :disabled="loadingUpdate"
                                                        @valueChange="(v) => {form.ine_required = (v == true ? 1:0); this.update()}"
                                                        class="mx-3 documents-check"
                                                    ></checkboxForm>
                                                    <fileInputForm
                                                        name="p2"
                                                        label="Identificación oficial (INE)"
                                                        :multiple="false"
                                                        :valueInput="form.ine_file"
                                                        :url="form.ine_url"
                                                        :rule="[]"
                                                        :showDelete="form.ine_showDelete"
                                                        :disabled="form.ine_showDelete == false ? true : loadingUpdate"
                                                        @cleared:file="(v) => { this.openDeleteDocument('ine_url')}"
                                                        @valueChange="(v) => {form.ine_file = v; delete serverErrors[`documentation.IDENTIFICACIÓN OFICIAL`]; this.update()}"
                                                        :errorMessages="serverErrors[`documentation.IDENTIFICACIÓN OFICIAL`]"

                                                        class="width-available"
                                                    ></fileInputForm>
                                                </div>
                                            </v-col>

                                            <v-col  v-permission:unless="'integradora_user.show'">
                                                <div class="d-flex">
                                                    <checkboxForm
                                                        label=""
                                                        :valueInput="form.psychometricTest_required"
                                                        :rule="[]"
                                                        :disabled="loadingUpdate"
                                                        @valueChange="(v) => {form.psychometricTest_required = (v == true ? 1:0); this.update()}"
                                                        class="mx-3 documents-check"
                                                    ></checkboxForm>
                                                    <fileInputForm
                                                        name="p2"
                                                        label="Pruebas psicométricas"
                                                        :multiple="false"
                                                        :valueInput="form.psychometricTest_file"
                                                        :rule="[]"
                                                        :url="form.psychometricTest_url"
                                                        :disabled="loadingUpdate"
                                                        @cleared:file="(v) => { this.openDeleteDocument('psychometricTest_url')}"
                                                        @valueChange="(v) => {form.psychometricTest_file = v; delete serverErrors[`documentation.PRUEBA PSICOMÉTRICA`]; this.update()}"
                                                        :errorMessages="serverErrors[`documentation.PRUEBA PSICOMÉTRICA`]"
                                                        class="width-available"
                                                    ></fileInputForm>
                                                </div>
                                            </v-col>
                                        </v-row>

                                        <v-row justify="center">
                                            <v-col cols="12" md="6">
                                                <div class="d-flex">
                                                    <checkboxForm
                                                        v-if="form.curp_showRequired"
                                                        label=""
                                                        :valueInput="form.curp_required"
                                                        :rule="[]"
                                                        :disabled="loadingUpdate"
                                                        @valueChange="(v) => {form.curp_required = (v == true ? 1:0); this.update()}"
                                                        class="mx-3 documents-check"
                                                    ></checkboxForm>
                                                    <fileInputForm
                                                        name="p2"
                                                        label="C.U.R.P."
                                                        :multiple="false"
                                                        :valueInput="form.curp_file"
                                                        :url="form.curp_url"
                                                        :rule="[]"
                                                        :showDelete="form.curp_showDelete"
                                                        :disabled="form.curp_showDelete == false ? true : loadingUpdate"
                                                        @cleared:file="(v) => { this.openDeleteDocument('curp_url')}"
                                                        @valueChange="(v) => {form.curp_file = v; delete serverErrors[`documentation.CURP`]; this.update()}"
                                                        :errorMessages="serverErrors[`documentation.CURP`]"

                                                        class="width-available"
                                                    ></fileInputForm>
                                                </div>
                                            </v-col>

                                            <v-col  v-permission:unless="'integradora_user.show'">
                                                <div class="d-flex">
                                                    <checkboxForm
                                                        label=""
                                                        :valueInput="form.internalRules_required"
                                                        :rule="[]"
                                                        :disabled="loadingUpdate"
                                                        @valueChange="(v) => {form.internalRules_required = (v == true ? 1:0); this.update()}"
                                                        class="mx-3 documents-check"
                                                    ></checkboxForm>
                                                    <fileInputForm
                                                        name="p2"
                                                        label="Reglamento interno de trabajo"
                                                        :multiple="false"
                                                        :valueInput="form.internalRules_file"
                                                        :url="form.internalRules_url"
                                                        :rule="[]"
                                                        :disabled="loadingUpdate"
                                                        @cleared:file="(v) => { this.openDeleteDocument('internalRules_url')}"
                                                        @valueChange="(v) => {form.internalRules_file = v; delete serverErrors[`documentation.REGLAMENTO INTERNO`]; this.update()}"
                                                        :errorMessages="serverErrors[`documentation.REGLAMENTO INTERNO`]"
                                                        class="width-available"
                                                    ></fileInputForm>
                                                </div>
                                            </v-col>
                                        </v-row>

                                        <v-row justify="center">
                                            <v-col cols="12" md="6">
                                                <div class="d-flex">
                                                    <checkboxForm
                                                        v-if="form.rfc_showRequired"
                                                        label=""
                                                        :valueInput="form.rfc_required"
                                                        :rule="[]"
                                                        :disabled="loadingUpdate"
                                                        @valueChange="(v) => {form.rfc_required = (v == true ? 1:0); this.update()}"
                                                        class="mx-3 documents-check"
                                                    ></checkboxForm>
                                                    <fileInputForm
                                                        name="p2"
                                                        label="R.F.C."
                                                        :multiple="false"
                                                        :valueInput="form.rfc_file"
                                                        :url="form.rfc_url"
                                                        :rule="[]"
                                                        :showDelete="form.rfc_showDelete"
                                                        :disabled="form.rfc_showDelete == false ? true : loadingUpdate"
                                                        @cleared:file="(v) => { this.openDeleteDocument('rfc_url')}"
                                                        @valueChange="(v) => {form.rfc_file = v; delete serverErrors[`documentation.RFC`]; this.update()}"
                                                        :errorMessages="serverErrors[`documentation.RFC`]"
                                                        class="width-available"
                                                    ></fileInputForm>
                                                </div>
                                            </v-col>

                                            <v-col  v-permission:unless="'integradora_user.show'">
                                                <div class="d-flex">
                                                    <checkboxForm
                                                        label=""
                                                        :valueInput="form.confidential_required"
                                                        :rule="[]"
                                                        :disabled="loadingUpdate"
                                                        @valueChange="(v) => {form.confidential_required = (v == true ? 1:0); this.update()}"
                                                        class="mx-3 documents-check"
                                                    ></checkboxForm>
                                                    <fileInputForm
                                                        name="p2"
                                                        label="Convenio de confidencialidad"
                                                        :multiple="false"
                                                        :valueInput="form.confidential_file"
                                                        :url="form.confidential_url"
                                                        :rule="[]"
                                                        :disabled="loadingUpdate"
                                                        @cleared:file="(v) => { this.openDeleteDocument('confidential_url')}"
                                                        @valueChange="(v) => {form.confidential_file = v; delete serverErrors[`documentation.CONVENCIO CONFIDENCIAL`]; this.update()}"
                                                        :errorMessages="serverErrors[`documentation.CONVENCIO CONFIDENCIAL`]"
                                                        class="width-available"
                                                    ></fileInputForm>
                                                </div>
                                            </v-col>
                                        </v-row>


                                        <v-row justify="center">
                                            <v-col cols="12" md="6">
                                                <div class="d-flex">
                                                    <checkboxForm
                                                        v-if="form.nss_showRequired"
                                                        label=""
                                                        :valueInput="form.nss_required"
                                                        :rule="[]"
                                                        :disabled="loadingUpdate"
                                                        @valueChange="(v) => {form.nss_required = (v == true ? 1:0); this.update()}"
                                                        class="mx-3 documents-check"
                                                    ></checkboxForm>
                                                    <fileInputForm
                                                        name="p2"
                                                        label="N.S.S."
                                                        :multiple="false"
                                                        :valueInput="form.nss_file"
                                                        :url="form.nss_url"
                                                        :rule="[]"
                                                        :showDelete="form.nss_showDelete"
                                                        :disabled="form.nss_showDelete == false ? true : loadingUpdate"
                                                        @cleared:file="(v) => { this.openDeleteDocument('nss_url')}"
                                                        @valueChange="(v) => {form.nss_file = v; delete serverErrors[`documentation.NSS`]; this.update()}"
                                                        :errorMessages="serverErrors[`documentation.NSS`]"

                                                        class="width-available"
                                                    ></fileInputForm>
                                                </div>

                                            </v-col>

                                            <v-col  v-permission:unless="'integradora_user.show'">
                                                <div class="d-flex">
                                                    <checkboxForm
                                                        label=""
                                                        :valueInput="form.payment_required"
                                                        :rule="[]"
                                                        :disabled="loadingUpdate"
                                                        @valueChange="(v) => {form.payment_required = (v == true ? 1:0); this.update()}"
                                                        class="mx-3 documents-check"
                                                    ></checkboxForm>
                                                    <fileInputForm
                                                        name="p2"
                                                        label="Propuesta económica"
                                                        :multiple="false"
                                                        :valueInput="form.payment_file"
                                                        :url="form.payment_url"
                                                        :rule="[]"
                                                        :disabled="loadingUpdate"
                                                        @cleared:file="(v) => { this.openDeleteDocument('payment_url')}"
                                                        @valueChange="(v) => {form.payment_file = v; delete serverErrors[`documentation.PROPUESTA ECONÓMICA`]; this.update()}"
                                                        :errorMessages="serverErrors[`documentation.PROPUESTA ECONÓMICA`]"
                                                        class="width-available"
                                                    ></fileInputForm>
                                                </div>
                                            </v-col>
                                        </v-row>

                                        <v-row justify="center">
                                            <v-col cols="12" md="6">
                                                <div class="d-flex">
                                                    <checkboxForm
                                                        v-if="form.proofResidency_showRequired"
                                                        label=""
                                                        :valueInput="form.proofResidency_required"
                                                        :rule="[]"
                                                        :disabled="loadingUpdate"
                                                        @valueChange="(v) => {form.proofResidency_required = (v == true ? 1:0); this.update()}"
                                                        class="mx-3 documents-check"
                                                    ></checkboxForm>
                                                    <fileInputForm
                                                        name="p2"
                                                        label="Comprobante de domicilio"
                                                        :multiple="false"
                                                        :valueInput="form.proofResidency_file"
                                                        :url="form.proofResidency_url"
                                                        :rule="[]"
                                                        :showDelete="form.proofResidency_showDelete"
                                                        :disabled="form.proofResidency_showDelete == false ? true : loadingUpdate"
                                                        @cleared:file="(v) => { this.openDeleteDocument('proofResidency_url')}"
                                                        @valueChange="(v) => {form.proofResidency_file = v; delete serverErrors[`documentation.COMPROBANTE DE DOMICILIO`]; this.update()}"
                                                        :errorMessages="serverErrors[`documentation.COMPROBANTE DE DOMICILIO`]"
                                                        class="width-available"
                                                    ></fileInputForm>
                                                </div>
                                            </v-col>

                                            <v-col  v-permission:unless="'integradora_user.show'">
                                                <div class="d-flex">
                                                    <checkboxForm
                                                        label=""
                                                        :valueInput="form.medicalTest_required"
                                                        :rule="[]"
                                                        :disabled="loadingUpdate"
                                                        @valueChange="(v) => {form.medicalTest_required = (v == true ? 1:0); this.update()}"
                                                        class="mx-3 documents-check"
                                                    ></checkboxForm>
                                                    <fileInputForm
                                                        name="p2"
                                                        label="Examen médico (opcional)"
                                                        :multiple="false"
                                                        :valueInput="form.medicalTest_file"
                                                        :url="form.medicalTest_url"
                                                        :rule="[]"
                                                        :disabled="loadingUpdate"
                                                        @cleared:file="(v) => { this.openDeleteDocument('medicalTest_url')}"
                                                        @valueChange="(v) => {form.medicalTest_file = v; delete serverErrors[`documentation.EXAMEN MÉDICO`]; this.update()}"
                                                        :errorMessages="serverErrors[`documentation.EXAMEN MÉDICO`]"
                                                        class="width-available"
                                                    ></fileInputForm>
                                                </div>
                                            </v-col>
                                        </v-row>

                                        <v-row v-permission:unless="'integradora_user.show'">
                                            <v-col cols="12" md="6">
                                                <div class="d-flex">
                                                    <checkboxForm
                                                        label=""
                                                        :valueInput="form.studyCert_required"
                                                        :rule="[]"
                                                        :disabled="loadingUpdate"
                                                        @valueChange="(v) => {form.studyCert_required = (v == true ? 1:0); this.update()}"
                                                        class="mx-3 documents-check"
                                                    ></checkboxForm>
                                                    <fileInputForm
                                                        name="p2"
                                                        label="Último certificado de estudios"
                                                        :multiple="false"
                                                        :valueInput="form.studyCert_file"
                                                        :url="form.studyCert_url"
                                                        :rule="[]"
                                                        :disabled="loadingUpdate"
                                                        @cleared:file="(v) => { this.openDeleteDocument('studyCert_url')}"
                                                        @valueChange="(v) => {form.studyCert_file = v; delete serverErrors[`documentation.CERTIFICADO DE ESTUDIOS`]; this.update()}"
                                                        :errorMessages="serverErrors[`documentation.CERTIFICADO DE ESTUDIOS`]"
                                                        class="width-available"
                                                    ></fileInputForm>
                                                </div>
                                            </v-col>

                                            <v-col>
                                                <div class="d-flex">
                                                    <checkboxForm
                                                        label=""
                                                        :valueInput="form.letter_required"
                                                        :rule="[]"
                                                        :disabled="loadingUpdate"
                                                        @valueChange="(v) => {form.letter_required = (v == true ? 1:0); this.update()}"
                                                        class="mx-3 documents-check"
                                                    ></checkboxForm>
                                                    <fileInputForm
                                                        name="p2"
                                                        label="Carta de no antecedentes penales (opcional)"
                                                        :multiple="false"
                                                        :valueInput="form.letter_file"
                                                        :url="form.letter_url"
                                                        :rule="[]"
                                                        :disabled="loadingUpdate"
                                                        @cleared:file="(v) => { this.openDeleteDocument('letter_url')}"
                                                        @valueChange="(v) => {form.letter_file = v; delete serverErrors[`documentation.ANTECEDENTES PENALES`]; this.update()}"
                                                        :errorMessages="serverErrors[`documentation.ANTECEDENTES PENALES`]"
                                                        class="width-available"
                                                    ></fileInputForm>
                                                </div>
                                            </v-col>
                                        </v-row>


                                        <v-row  v-permission:unless="'integradora_user.show'">
                                            <v-col cols="12" md="6">
                                                <div class="d-flex">
                                                    <checkboxForm
                                                        label=""
                                                        :valueInput="form.economyStudy_required"
                                                        :rule="[]"
                                                        :disabled="loadingUpdate"
                                                        @valueChange="(v) => {form.economyStudy_required = (v == true ? 1:0); this.update()}"
                                                        class="mx-3 documents-check"
                                                    ></checkboxForm>
                                                    <fileInputForm
                                                        name="p2"
                                                        label="Estudio socioeconómico"
                                                        :multiple="false"
                                                        :valueInput="form.economyStudy_file"
                                                        :url="form.economyStudy_url"
                                                        :rule="[]"
                                                        :disabled="loadingUpdate"
                                                        @cleared:file="(v) => { this.openDeleteDocument('economyStudy_url')}"
                                                        @valueChange="(v) => {form.economyStudy_file = v; delete serverErrors[`documentation.ESTUDIO SOCIOECONÓMICO`]; this.update()}"
                                                        :errorMessages="serverErrors[`documentation.ESTUDIO SOCIOECONÓMICO`]"
                                                        class="width-available"
                                                    ></fileInputForm>
                                                </div>
                                            </v-col>

                                            <v-col cols="12" md="6">
                                                <div class="d-flex">
                                                    <checkboxForm
                                                        label=""
                                                        :valueInput="form.epp_required"
                                                        :rule="[]"
                                                        :disabled="loadingUpdate"
                                                        @valueChange="(v) => {form.epp_required = (v == true ? 1:0); this.update()}"
                                                        class="mx-3 documents-check"
                                                    ></checkboxForm>
                                                    <fileInputForm
                                                        name="p2"
                                                        label="Vale de equipo de protección personal (opcional)"
                                                        :multiple="false"
                                                        :valueInput="form.epp_file"
                                                        :url="form.epp_url"
                                                        :rule="[]"
                                                        :disabled="loadingUpdate"
                                                        @cleared:file="(v) => { this.openDeleteDocument('epp_url')}"
                                                        @valueChange="(v) => {form.epp_file = v; delete serverErrors[`documentation.VALE DE EQUIPO DE PROTECCIÓN PERSONAL`]; this.update()}"
                                                        :errorMessages="serverErrors[`documentation.VALE DE EQUIPO DE PROTECCIÓN PERSONAL`]"
                                                        class="width-available"
                                                    ></fileInputForm>
                                                </div>
                                            </v-col>
                                        </v-row>

                                        <v-row  v-permission:unless="'integradora_user.show'">


                                            <v-col cols="12" md="6">
                                                <div class="d-flex">
                                                    <checkboxForm
                                                        label=""
                                                        :valueInput="form.ret_infonavit_required"
                                                        :rule="[]"
                                                        :disabled="loadingUpdate"
                                                        @valueChange="(v) => {form.ret_infonavit_required = (v == true ? 1:0); this.update()}"
                                                        class="mx-3 documents-check"
                                                    ></checkboxForm>
                                                    <fileInputForm
                                                        name="p2"
                                                        label="Aviso de retención INFONAVIT"
                                                        :multiple="false"
                                                        :valueInput="form.ret_infonavit_file"
                                                        :url="form.ret_infonavit_url"
                                                        :rule="[]"
                                                        :disabled="loadingUpdate"
                                                        @cleared:file="(v) => { this.openDeleteDocument('ret_infonavit_url')}"
                                                        @valueChange="(v) => {form.ret_infonavit_file = v; delete serverErrors[`documentation.AVISO DE RETENCIÓN INFONAVIT`]; this.update()}"
                                                        :errorMessages="serverErrors[`documentation.AVISO DE RETENCIÓN INFONAVIT`]"
                                                        class="width-available"
                                                    ></fileInputForm>
                                                </div>
                                            </v-col>

                                            <v-col cols="12" md="6">
                                                <div class="d-flex">
                                                    <checkboxForm
                                                        label=""
                                                        :valueInput="form.waiver_equipment_required"
                                                        :rule="[]"
                                                        :disabled="loadingUpdate"
                                                        @valueChange="(v) => {form.waiver_equipment_required = (v == true ? 1:0); this.update()}"
                                                        class="mx-3 documents-check"
                                                    ></checkboxForm>
                                                    <fileInputForm
                                                        name="p2"
                                                        label="Carta responsiva de equipo (opcional)"
                                                        :multiple="false"
                                                        :valueInput="form.waiver_equipment_file"
                                                        :url="form.waiver_equipment_url"
                                                        :rule="[]"
                                                        :disabled="loadingUpdate"
                                                        @cleared:file="(v) => { this.openDeleteDocument('waiver_equipment_url')}"
                                                        @valueChange="(v) => {form.waiver_equipment_file = v; delete serverErrors[`documentation.CARTA RESPONSIVA DE EQUIPO`]; this.update()}"
                                                        :errorMessages="serverErrors[`documentation.CARTA RESPONSIVA DE EQUIPO`]"
                                                        class="width-available"
                                                    ></fileInputForm>
                                                </div>
                                            </v-col>
                                        </v-row>

                                        <v-row  justify="center">


                                            <v-col cols="12" md="6" v-permission:unless="'integradora_user.show'">
                                                <div class="d-flex">
                                                    <checkboxForm
                                                        label=""
                                                        :valueInput="form.ret_fonacot_required"
                                                        :rule="[]"
                                                        :disabled="loadingUpdate"
                                                        @valueChange="(v) => {form.ret_fonacot_required = (v == true ? 1:0); this.update()}"
                                                        class="mx-3 documents-check"
                                                    ></checkboxForm>
                                                    <fileInputForm
                                                        name="p2"
                                                        label="Aviso de retención FONACOT"
                                                        :multiple="false"
                                                        :valueInput="form.ret_fonacot_file"
                                                        :url="form.ret_fonacot_url"
                                                        :rule="[]"
                                                        :disabled="loadingUpdate"
                                                        @cleared:file="(v) => { this.openDeleteDocument('ret_fonacot_url')}"
                                                        @valueChange="(v) => {form.ret_fonacot_file = v; delete serverErrors[`documentation.AVISO DE RETENCIÓN FONACOT`]; this.update()}"
                                                        :errorMessages="serverErrors[`documentation.AVISO DE RETENCIÓN FONACOT`]"
                                                        class="width-available"
                                                    ></fileInputForm>
                                                </div>
                                            </v-col>

                                            <v-col cols="12" md="6">
                                                <div class="d-flex">
                                                    <checkboxForm
                                                        v-if="form.cv_showRequired"
                                                        label=""
                                                        :valueInput="form.cv_required"
                                                        :rule="[]"
                                                        :disabled="loadingUpdate"
                                                        @valueChange="(v) => {form.cv_required = (v == true ? 1:0); this.update()}"
                                                        class="mx-3 documents-check"
                                                    ></checkboxForm>
                                                    <fileInputForm
                                                        name="p2"
                                                        label="Curriculum"
                                                        :multiple="false"
                                                        :valueInput="form.cv_file"
                                                        :url="form.cv_url"
                                                        :showDelete="form.cv_showDelete"
                                                        :rule="[]"
                                                        :disabled="form.cv_showDelete == false ? true : loadingUpdate"
                                                        @cleared:file="(v) => { this.openDeleteDocument('cv_url')}"
                                                        @valueChange="(v) => {form.cv_file = v; delete serverErrors[`documentation.CURRICULUM VITAE`]; this.update()}"
                                                        :errorMessages="serverErrors[`documentation.CURRICULUM VITAE`]"

                                                        class="width-available"
                                                    ></fileInputForm>
                                                </div>

                                            </v-col>


                                        </v-row>

                                         <!-- EXTRA 
                                        <v-row  justify="start">

                                            <v-col cols="12" md="6">
                                                <div class="d-flex">
                                                    <checkboxForm
                                                        v-if="form.tax_cert_showRequired"
                                                        label=""
                                                        :valueInput="form.tax_cert_required"
                                                        :rule="[]"
                                                        :disabled="loadingUpdate"
                                                        @valueChange="(v) => {form.tax_cert_required = (v == true ? 1:0); this.update()}"
                                                        class="mx-3 documents-check"
                                                    ></checkboxForm>
                                                    <fileInputForm
                                                        name="p2"
                                                        label="CONSTANCIA DE SITUACIÓN FISCAL"
                                                        :multiple="false"
                                                        :valueInput="form.tax_cert_file"
                                                        :url="form.tax_cert_url"
                                                        :showDelete="form.tax_cert_showDelete"
                                                        :rule="[]"
                                                        :disabled="form.tax_cert_showDelete == false ? true : loadingUpdate"
                                                        @cleared:file="(v) => { this.openDeleteDocument('tax_cert_url')}"
                                                        @valueChange="(v) => {form.tax_cert_file = v; delete serverErrors[`documentation.CONSTANCIA DE SITUACIÓN FISCAL`]; this.update()}"
                                                        :errorMessages="serverErrors[`documentation.CONSTANCIA DE SITUACIÓN FISCAL`]"

                                                        class="width-available"
                                                    ></fileInputForm>
                                                </div>

                                            </v-col>


                                        </v-row>
                                        -->

                                        <v-row  justify="start">

                                            <v-col cols="12" md="6">
                                                <div class="d-flex">
                                                    <checkboxForm
                                                        v-if="form.labo_showRequired"
                                                        label=""
                                                        :valueInput="form.labo_required"
                                                        :rule="[]"
                                                        :disabled="loadingUpdate"
                                                        @valueChange="(v) => {form.labo_required = (v == true ? 1:0); this.update()}"
                                                        class="mx-3 documents-check"
                                                    ></checkboxForm>
                                                    <fileInputForm
                                                        name="p2"
                                                        label="Laboratorios"
                                                        :multiple="false"
                                                        :valueInput="form.labo_file"
                                                        :url="form.labo_url"
                                                        :showDelete="form.labo_showDelete"
                                                        :rule="[]"
                                                        :disabled="form.labo_showDelete == false ? true : loadingUpdate"
                                                        @cleared:file="(v) => { this.openDeleteDocument('labo_url')}"
                                                        @valueChange="(v) => {form.labo_file = v; delete serverErrors[`documentation.LABORATORIOS`]; this.update()}"
                                                        :errorMessages="serverErrors[`documentation.LABORATORIOS`]"
                                                        
                                                        class="width-available"
                                                    ></fileInputForm>
                                                </div>
                                            
                                            </v-col>

                                           
                                        </v-row>

                                        <!-- EXTRA -->
                                        <v-row  v-permission:unless="'integradora_user.show'">
                                            <v-col class="text-left pb-0">
                                                <div class="font-weight-bold body-1">
                                                    Documentos Extra
                                                </div>
                                            </v-col>

                                        </v-row>

                                        <v-row  v-permission:unless="'integradora_user.show'">
                                            <v-col cols="12" md="6" class="">
                                                <div class="d-flex">

                                                    <fileInputForm
                                                        name="p2"
                                                        label="Selecciona un documento"
                                                        :multiple="true"
                                                        :valueInput="form.newEmployeeFiles"
                                                        :url="''"
                                                        :rule="[]"
                                                        :disabled="loadingMiscUpdate"
                                                        :loading="loadingMiscUpdate"
                                                        @valueChange="(v) => {form.newEmployeeFiles = v; delete serverErrors[`new_employee_files`];}"
                                                        :errorMessages="serverErrors[`new_employee_files`]"
                                                        v-on:update:url="form.economyStudy_url = $event"
                                                        class="width-available mr-2"
                                                    ></fileInputForm>

                                                    <secondary-button :props="miscUpdateBtnData" class=""></secondary-button>


                                                </div>
                                            </v-col>
                                        </v-row>

                                        <v-row>
                                            <v-col v-for="(item, index) in form.miscFiles" :key="index" cols="12" md="6">
                                                <fileInputForm

                                                    :label="getMiscFileName(item.file)"
                                                    :multiple="false"
                                                    :valueInput="[]"
                                                    :url="item.file_url"
                                                    :rule="[]"
                                                    :disabled="true"
                                                    :loading="item.loading"

                                                    @cleared:file="(v) => {openDeleteDocument(item, true)}"

                                                    class="width-available"
                                                ></fileInputForm>
                                            </v-col>

                                        </v-row>

                                    </v-form>


                                </v-tab-item>


                                <!-- Docs. Baja -->
                                <v-tab-item value="8" v-if="showCutBack">
                                   <v-row>
                                        <v-col class="text-left ml-4">
                                            <div class=" body-1 mb-2">
                                                <span class="font-weight-bold">DOCUMENTACIÓN OFICIAL DE BAJA DE COLABORADOR</span> <span class="font-weight-bold"> ({{docCutBackTotalsString}}) </span>
                                            </div>
                                            <v-progress-linear background-color="inputsBackground" :indeterminate="loadingUpdate" :value=" loadingUpdate ? '0': percReqDocCutBack" color="success" height="10"></v-progress-linear>
                                        </v-col>

                                    </v-row>
                                    <v-form ref="formCutBack" @submit.prevent="updateCutBack">

                                        <v-row>
                                            <v-col cols="12" md="6">
                                                <div class="d-flex">
                                                    <fileInputForm
                                                        name="p2"
                                                        label="COMPROBANTE DE ENTREGA DE FINIQUITO Y/O LIQUIDACIÓN"
                                                        :multiple="false"
                                                        :valueInput="formCutBack.voucher_finiquito_file"
                                                        :url="formCutBack.voucher_finiquito_url"
                                                        :rule="[]"
                                                        :disabled="loadingUpdate"
                                                        @cleared:file="(v) => { this.openDeleteDocumentCutBack('voucher_finiquito_url')}"
                                                        @valueChange="(v) => {formCutBack.voucher_finiquito_file = v; delete serverErrors[`documentation.COMPROBANTE DE ENTREGA DE FINIQUITO Y/O LIQUIDACIÓN`]; this.updateCutBack()}"
                                                        :errorMessages="serverErrors[`documentation.COMPROBANTE DE ENTREGA DE FINIQUITO Y/O LIQUIDACIÓN`]"

                                                        class="width-available"
                                                    ></fileInputForm>
                                                </div>

                                            </v-col>

                                            <v-col cols="12" md="6">
                                                <div class="d-flex">
                                                    <fileInputForm
                                                        name="p2"
                                                        label="VALE ENTREGA DE EQUIPO DE SEGURIDAD Y/O HERRAMIENTA DE TRABAJO"
                                                        :multiple="false"
                                                        :valueInput="formCutBack.voucher_equipment_return_file"
                                                        :url="formCutBack.voucher_equipment_return_url"
                                                        :rule="[]"
                                                        :disabled="loadingUpdate"
                                                        @cleared:file="(v) => { this.openDeleteDocumentCutBack('voucher_equipment_return_url')}"
                                                        @valueChange="(v) => {formCutBack.voucher_equipment_return_file = v; delete serverErrors[`documentation.VALE ENTREGA DE EQUIPO DE SEGURIDAD Y/O HERRAMIENTA DE TRABAJO`]; this.updateCutBack()}"
                                                        :errorMessages="serverErrors[`documentation.VALE ENTREGA DE EQUIPO DE SEGURIDAD Y/O HERRAMIENTA DE TRABAJO`]"

                                                        class="width-available"
                                                    ></fileInputForm>
                                                </div>

                                            </v-col>
                                        </v-row>

                                        <v-row>
                                            <v-col cols="12" md="6">
                                                <div class="d-flex">
                                                    <fileInputForm
                                                        name="p2"
                                                        label="COMPROBANTE DE BAJA DEL IMSS"
                                                        :multiple="false"
                                                        :valueInput="formCutBack.cutBack_imss_file"
                                                        :url="formCutBack.cutBack_imss_url"
                                                        :rule="[]"
                                                        :disabled="loadingUpdate"
                                                        @cleared:file="(v) => { this.openDeleteDocumentCutBack('cutBack_imss_url')}"
                                                        @valueChange="(v) => {formCutBack.cutBack_imss_file = v; delete serverErrors[`documentation.COMPROBANTE DE BAJA DEL IMSS`]; this.updateCutBack()}"
                                                        :errorMessages="serverErrors[`documentation.COMPROBANTE DE BAJA DEL IMSS`]"

                                                        class="width-available"
                                                    ></fileInputForm>
                                                </div>

                                            </v-col>

                                            <v-col cols="12" md="6">
                                                <div class="d-flex">
                                                    <fileInputForm
                                                        name="p2"
                                                        label="VALE ENTREGA DE LAPTOP Y MOUSE (SIN CONTRASEÑA)"
                                                        :multiple="false"
                                                        :valueInput="formCutBack.voucher_computer_return_file"
                                                        :url="formCutBack.voucher_computer_return_url"
                                                        :rule="[]"
                                                        :disabled="loadingUpdate"
                                                        @cleared:file="(v) => { this.openDeleteDocumentCutBack('voucher_computer_return_url')}"
                                                        @valueChange="(v) => {formCutBack.voucher_computer_return_file = v; delete serverErrors[`documentation.VALE ENTREGA DE LAPTOP Y MOUSE (SIN CONTRASEÑA)`]; this.updateCutBack()}"
                                                        :errorMessages="serverErrors[`documentation.VALE ENTREGA DE LAPTOP Y MOUSE (SIN CONTRASEÑA)`]"

                                                        class="width-available"
                                                    ></fileInputForm>
                                                </div>

                                            </v-col>
                                        </v-row>

                                        <v-row>
                                            <v-col cols="12" md="6">
                                                <div class="d-flex">
                                                    <fileInputForm
                                                        name="p2"
                                                        label="COMPROBANTE BAJA EN SISTEMAS OPERACIONALES Y HUELLA DE INGRESO"
                                                        :multiple="false"
                                                        :valueInput="formCutBack.voucher_removed_sistem_file"
                                                        :url="formCutBack.voucher_removed_sistem_url"
                                                        :rule="[]"
                                                        :disabled="loadingUpdate"
                                                        @cleared:file="(v) => { this.openDeleteDocumentCutBack('voucher_removed_sistem_url')}"
                                                        @valueChange="(v) => {formCutBack.voucher_removed_sistem_file = v; delete serverErrors[`documentation.COMPROBANTE BAJA EN SISTEMAS OPERACIONALES Y HUELLA DE INGRESO`]; this.updateCutBack()}"
                                                        :errorMessages="serverErrors[`documentation.COMPROBANTE BAJA EN SISTEMAS OPERACIONALES Y HUELLA DE INGRESO`]"

                                                        class="width-available"
                                                    ></fileInputForm>
                                                </div>

                                            </v-col>

                                            <v-col cols="12" md="6">
                                                <div class="d-flex">
                                                    <fileInputForm
                                                        name="p2"
                                                        label="VALE DE ENTREGA DE CELULAR Y/O RADIO"
                                                        :multiple="false"
                                                        :valueInput="formCutBack.voucher_phone_return_file"
                                                        :url="formCutBack.voucher_phone_return_url"
                                                        :rule="[]"
                                                        :disabled="loadingUpdate"
                                                        @cleared:file="(v) => { this.openDeleteDocumentCutBack('voucher_phone_return_url')}"
                                                        @valueChange="(v) => {formCutBack.voucher_phone_return_file = v; delete serverErrors[`documentation.VALE DE ENTREGA DE CELULAR Y/O RADIO`]; this.updateCutBack()}"
                                                        :errorMessages="serverErrors[`documentation.VALE DE ENTREGA DE CELULAR Y/O RADIO`]"

                                                        class="width-available"
                                                    ></fileInputForm>
                                                </div>

                                            </v-col>
                                        </v-row>

                                        <v-row>
                                            <v-col cols="12" md="6">
                                                <div class="d-flex">
                                                    <fileInputForm
                                                        name="p2"
                                                        label="COMPROBANTE DE CAMBIO DE CONTRASEÑA DE CORREO INSTITUCIONAL"
                                                        :multiple="false"
                                                        :valueInput="formCutBack.voucher_change_email_file"
                                                        :url="formCutBack.voucher_change_email_url"
                                                        :rule="[]"
                                                        :disabled="loadingUpdate"
                                                        @cleared:file="(v) => { this.openDeleteDocumentCutBack('voucher_change_email_url')}"
                                                        @valueChange="(v) => {formCutBack.voucher_change_email_file = v; delete serverErrors[`documentation.COMPROBANTE DE CAMBIO DE CONTRASEÑA DE CORREO INSTITUCIONAL`]; this.updateCutBack()}"
                                                        :errorMessages="serverErrors[`documentation.COMPROBANTE DE CAMBIO DE CONTRASEÑA DE CORREO INSTITUCIONAL`]"

                                                        class="width-available"
                                                    ></fileInputForm>
                                                </div>

                                            </v-col>

                                            <v-col cols="12" md="6">


                                            </v-col>
                                        </v-row>




                                    </v-form>

                                </v-tab-item>



                                <!-- ENCUESTA DE SALIDA -->
                                <v-tab-item value="10">

                                    <div class="mt-2">

                                        <v-row class="my-0 mx-1" v-if="loadingSurvey">
                                            <v-col class="py-2 text-center">
                                                <v-progress-circular
                                                indeterminate
                                                color="primary"
                                                ></v-progress-circular>
                                            </v-col>
                                        </v-row>
                                        <template v-if="!loadingSurvey">

                                            <v-row justify="center">
                                                <v-col cols="12" lg="7">
                                                    <SurveyResponses :values="surveyData"></SurveyResponses>
                                                </v-col>
                                            </v-row>
                                        </template>

                                    </div>
                                </v-tab-item>

                            </v-tabs-items>


                        </v-col>
                    </v-row>

                </div>
            </template>
        </contentCard>


        <!-- DELETE EVENTS -->
		<modal :props="modalProps" @modalResponse="method_handler">
			<!-- Buttons -->
			<template slot="cardActions">
				<v-row justify="end">
					<v-col  cols="12" md="4">
						<secondaryButton
							:props="cancelModal"
						></secondaryButton>
					</v-col>
					<v-col  cols="12" md="4">
						<primaryButton
							:props="acceptModal"
						></primaryButton>
					</v-col>
				</v-row>
			</template>
		</modal>

        <!-- DELETE FILES -->
        <modal :props="modalDocumentsProps" @modalResponse="method_handler">
			<!-- Buttons -->
			<template slot="cardActions">
				<v-row justify="end">
					<v-col cols="12" md="4">
						<secondaryButton
						:props="cancelDocumentsModal"
						></secondaryButton>
					</v-col>
					<v-col cols="12" md="4">
						<primaryButton
						:props="acceptDocumentsModal"
						></primaryButton>
					</v-col>
				</v-row>
			</template>
		</modal>



		<modal :props="modalDeleteVacationItemProps" @modalResponse="method_handler">
			<!-- Buttons -->
			<template slot="cardActions">
				<v-row justify="end">
					<v-col cols="12" md="4">
						<secondaryButton
							:props="cancelDeleteVacationItemModal"
						></secondaryButton>
					</v-col>
					<v-col cols="12" md="4">
						<primaryButton
							:props="acceptDeleteVacationItemModal"
						></primaryButton>
					</v-col>
				</v-row>
			</template>
		</modal>

        <!-- holiday modal -->
        <modal :props="modalHolidayProps" @modalResponse="method_handler">
            <!-- Body -->
            <template slot="cardBody">
                <datatable :props="tableVacationsDetail" @method_handler="method_handler">
                </datatable>
            </template>
			<!-- Buttons -->
			<template slot="cardActions">
				<v-row justify="end">

					<v-col cols="12" md="3">
						<primaryButton
							:props="cancelHolidayModal"
						></primaryButton>
					</v-col>
				</v-row>
			</template>
		</modal>



	</div>
</template>
<script>
import Utils from "../../../../helpers/Utils";
import DetailsItem from '../../../../components/DetailsItem.vue';
import separator from '../../../../components/Separator.vue';
import Object2Form from '../../../../helpers/Object2Form';
import SurveyResponses from './SurveyResponsesForm.vue';
import StatisticAssistenceCalendar from "./StatisticAssistenceCalendar.vue";
export default {
	components: {
        DetailsItem,
        separator,
        SurveyResponses,
        StatisticAssistenceCalendar
    },
    computed:{
        employeeInfo: function(){
            //return `00001 - Dulce Ulibarri - Grupo Merca`;
			return this.employeeText;
        },
        img: function(){
            // return "https://picsum.photos/id/11/500/300"

            return this.employeeImg;
        },

    },
	watch:{
		tab: function (value) {
            switch (value) {
				case '2':
					this.getEvents();
					break;

				case '3':
					console.log('Load Questionaries');
					break;

				case '4':
					this.getAssets();
					break;

                case '5':
                    this.getHoliday();
                    break;

                case '6':
                    this.getPosition(this.positionId);
                    break;

                case '8':
                    this.getCutBackDocuments()
                    break;

                case '9':
                    this.getYearSelect();
                    break;

                case '10':
                    this.getSurveyLayoff();
                    break;

			}
        }
	},
    data(){
		return {
            externalUserDocuments:[],
            infoLength: 7,
            loadingSurvey:false,
            surveyData: {},
            ut: Utils,
            loadingPayrolls:true,
            datesPayload:[],
            selectedYearPayrolls: "",
            typeEmployeePayroll: "",
            weeksPayroll: [],
            years: [],
            loadingUpdate:false,
            loadingMiscUpdate:false,
            loadingMiscDelete:false,
            showCutBack:false,
            documentSelected: "",
            filesLoading:[],
            id: this.$route.params.id,
			employeeText: '',
            employeeNumber: '',
            employeeImg: "",
            employeeName:"",
            generalPersonal: [],
            generalpayee: [],
            generalChildren:{info:[], children:[]},
            generalContract: [],
            generalSalary: [],
            files:[],
            docTotalsString: '',
            docCutBackTotalsString: "",
            percReqDoc: 0,
            percReqDocCutBack: 0,
			loading: false,
			tab: "1",
			loadingQuestionaries: false,
			eventsLoaded: false,
			questionariesLoaded: false,
			eventId:'',
            vacationId: "",
            yearVacationId:"",
			assetsLoadded: false,
            holidayLoaded: false,
            loadingPosition: false,
            positionId: "",
            serverErrors: {},
            miscUpdateBtnData: {
                text: "Guardar",
                icon: "",
                color: "primary",

                click: () => {this.updateMiscFiles()}
            },
            formCutBack: {
                //COMPROBANTE DE ENTREGA DE FINIQUITO Y/O LIQUIDACIÓN
                voucher_finiquito_file: [],
                voucher_finiquito_url: '',
                //VALE ENTREGA DE EQUIPO DE SEGURIDAD Y/O HERRAMIENTA DE TRABAJO
                voucher_equipment_return_file: [],
                voucher_equipment_return_url: '',
                //COMPROBANTE DE BAJA DEL IMSS
                cutBack_imss_file: [],
                cutBack_imss_url: '',
                //VALE ENTREGA DE LAPTOP Y MOUSE (SIN CONTRASEÑA)
                voucher_computer_return_file: [],
                voucher_computer_return_url: '',
                //VALE DE ENTREGA DE CELULAR Y/O RADIO
                voucher_phone_return_file: [],
                voucher_phone_return_url: '',
                //COMPROBANTE BAJA EN SISTEMAS OPERACIONALES Y HUELLA DE INGRESO
                voucher_removed_sistem_file: [],
                voucher_removed_sistem_url: '',
                //COMPROBANTE DE CAMBIO DE CONTRASEÑA DE CORREO INSTITUCIONAL
                voucher_change_email_file: [],
                voucher_change_email_url: '',

            },
            form: {
                /**GENERAL */
                employe_number: '',
                name: '',
                email: '',
                business_email: '',
                profession: '',
                birthplace: '',
                birthdate: '',
                gender: '',
                marital_status: '',
                curp: '',
                rfc: '',
                infonavit_number: '',
                fonacot_number: '',
                nss: '',
                phone: '',
                blood_type: '',
                diseases: [],
                other_diseases:'',
                country: '',
                street: '',
                ext_number: '',
                int_number: '',
                zip_code: '',
                neighborhood: '',
                city: '',
                state: '',
                emergency_contact: '',
                emergency_number: '',
                payee_name: '',
                payee_family_phone: '',
                payee_family_relationship: '',
                payee_rfc: '',
                payee_curp: '',
                payee_address_data: {
                    country: '',
                    zip_code: '',
                    neighborhood: '',
                    city: '',
                    state: '',
                },
                // payee_state: '',
                // payee_city: '',
                // payee_zip_code: '',
                // payee_neighborhood: '',
                payee_address: '',
                photo_file: [],
                photo_url: null,
                has_childs: false,
                children: [],

                /**DOCUMENTATION */
                birthCertificate_file: [],
                birthCertificate_url: '',
                birthCertificate_required: 0,
                birthCertificate_showDelete: true,
                birthCertificate_showRequired: true,
                ine_file: [],
                ine_url: '',
                ine_required: 0,
                ine_showDelete: true,
                ine_showRequired: true,
                curp_file: [],
                curp_url: '',
                curp_required: 0,
                curp_showDelete: true,
                curp_showRequired: true,
                rfc_file: [],
                rfc_url: '',
                rfc_required: 0,
                rfc_showDelete: true,
                rfc_showRequired: true,
                nss_file: [],
                nss_url: '',
                nss_required: 0,
                nss_showDelete: true,
                nss_showRequired: true,
                proofResidency_file: [],
                proofResidency_url: '',
                proofResidency_required: 0,
                proofResidency_showDelete: true,
                proofResidency_showRequired: true,
                studyCert_file: [],
                studyCert_url: '',
                studyCert_required: 0,
                studyCert_showDelete: true,
                studyCert_showRequired: true,
                economyStudy_file: [],
                economyStudy_url: '',
                economyStudy_required: 0,
                economyStudy_showDelete: true,
                economyStudy_showRequired: true,
                recomendationLetter_file: [],
                recomendationLetter_url: '',
                recomendationLetter_required: 0,
                recomendationLetter_showDelete: true,
                recomendationLetter_showRequired: true,
                psychometricTest_file: [],
                psychometricTest_url: '',
                psychometricTest_required: 0,
                psychometricTest_showDelete: true,
                psychometricTest_showRequired: true,
                internalRules_file: [],
                internalRules_url: '',
                internalRules_required: 0,
                internalRules_showDelete: true,
                internalRules_showRequired: true,
                confidential_file: [],
                confidential_url: '',
                confidential_required: 0,
                confidential_showDelete: true,
                confidential_showRequired: true,
                payment_file: [],
                payment_url: '',
                payment_required: 0,
                payment_showDelete: true,
                payment_showRequired: true,
                medicalTest_file: [],
                medicalTest_url: '',
                medicalTest_required: 0,
                medicalTest_showDelete: true,
                medicalTest_showRequired: true,
                letter_file: [],
                letter_url: '',
                letter_required: 0,
                letter_showDelete: true,
                letter_showRequired: true,
                miscFiles:[],
                newEmployeeFiles:[],
                deleteEmployeeFiles: [],
                ret_infonavit_file: [],
                ret_infonavit_url: '',
                ret_infonavit_required: 0,
                ret_infonavit_showDelete: true,
                ret_infonavit_showRequired: true,
                ret_fonacot_file: [],
                ret_fonacot_url: '',
                ret_fonacot_required: 0,
                ret_fonacot_showDelete: true,
                ret_fonacot_showRequired: true,
                epp_file: [],
                epp_url: '',
                epp_required: 0,
                epp_showDelete: true,
                epp_showRequired: true,
                waiver_equipment_file: [],
                waiver_equipment_url: '',
                waiver_equipment_required: 0,
                waiver_equipment_showDelete: true,
                waiver_equipment_showRequired: true,
                cv_file: [],
                cv_url: '',
                cv_required: 0,
                cv_showDelete: true,
                cv_showRequired: true,
                tax_cert_file: [],
                tax_cert_url: '',
                tax_cert_required: 0,
                tax_cert_showDelete: true,
                tax_cert_showRequired: true,
                labo_file: [],
                labo_url: '',
                labo_required: 0,
                labo_showDelete: true,
                labo_showRequired: true,

                /**HIRE */
                company: '',
                branch_office_id: '',
                admission_date: '',
                type: '',
                start_date:'',
                end_date: '',
                mode: '',
                position_id: '',
                payroll_type: '',
                fiscal_salary: '',
                integrated_salary: '',
                support_transportation: '',
                mealTimeCheck: '',
                repeatWeekdaysTimes: '', //FALTA EN BACK
                monday_schedule_start: '',
                monday_schedule_end: '',
                tuesday_schedule_start: '',
                tuesday_schedule_end: '',
                wednesday_schedule_start: '',
                wednesday_schedule_end: '',
                thursday_schedule_start: '',
                thursday_schedule_end: '',
                friday_schedule_start: '',
                friday_schedule_end: '',
                saturday_schedule_start: '',
                saturday_schedule_end: '',
                sunday_schedule_start: '',
                sunday_schedule_end: '',
                contract_file: [],
                contract_path: '',
                department_id: '',

                contract_multifiles: [],
                delete_contract_files: [],



            },
			qList: [
				// {text: "Cuestionario de clima laboral 2021", status: "Completo", id: 1},
				// {text: "Cuestionario de clima laboral 2020", status: "Completo", id: 2},
				// {text: "Cuestionario de manejo de la pandemia", status: "Completo", id: 3}
			],

            positionItems: [
                { concepto: 'Código', index: 'code', valor: '' },
                { concepto: 'Nombre', index: 'name', valor: null },
                { concepto: 'Empresa', index: 'company.name', valor: null},
                // { concepto: 'Área', index: 'area.name', valor: null},
                { concepto: 'Departamento', index: 'department.name', valor: null},
                { concepto: 'Requiere viajar', index: 'requires_travel', valor: null},
                { concepto: 'A cargo de gente', index: 'have_persons_in_charge', valor: null},
                { concepto: 'Requiere inglés', index: 'requires_english', valor: null},
                { concepto: 'Nivel de inglés requierido', index: 'english_level', valor: null},
                { concepto: 'Propósito del puesto', index: 'purpose', valor: null},
                { concepto: 'Reporta a', index: 'report_to.name', valor: null},
                { concepto: 'Supervisa a', index: 'supervise_to.name', valor: null},
                { concepto: 'Grado de estudios', index: 'studies', valor: null},
                { concepto: 'Experiencia previa (años)', index: 'experience', valor: null},
                { concepto: 'Formación (conocimientos específicos)', index: 'background', valor: null},
                { concepto: 'Habilidades', index: 'abilities', valor: null},
                { concepto: 'Responsabilidades', index: 'responsibilities', valor: null},
                { concepto: 'Tiene autoridad de', index: 'authority', valor: null},
            ],

            actionsVacation: [
                {
					name: 'Detail',
					icon: {
						color: 'secondary',
						icon: 'mdi-information-outline'
					},
					disabled: false,
					type: 'method',   //  method, external, redirect
					action: 'openHolidayDetailModal',
                    permissions: 'vacations.show'
				}

			],
            actionsVacationDetails: [

                {
					name: 'PDF',
					icon: {
						color: 'secondary',
						icon: 'mdi-printer-outline'
					},
					disabled: false,
					type: 'method',   //  method, external, redirect
					action: 'pdfVacations',
                    permissions: 'vacations.show'
				},
				{
					name: 'Edit',
					icon: {
						color: 'secondary',
						icon: 'mdi-pencil-outline'
					},
					disabled: false,
					type: 'redirect',   //  method, external, redirect
					action: '/obras/1/edicion',
                    permissions: 'vacations.update'
				},
				{
					name: 'Delete',
					icon: {
						color: 'secondary',
						icon: 'mdi-delete-outline'
					},
					disabled: false,
					type: 'method',   //  method, external, redirect
					action: 'openDeleteVacationModal',
                    permissions: 'vacations.delete'
				},
			],



			actions: [
				{
					name: 'Editar',
					icon: {
						color: 'secondary',
						icon: 'mdi-pencil-outline'
					},
					disabled: false,
					type: 'redirect',   //  method, external, redirect
					action: '/colaboradores/1/edicion'
				},
				{
					name: 'Borrar',
					icon: {
						color: 'secondary',
						icon: 'mdi-delete-outline'
					},
					disabled: false,
					type: 'method',   //  method, external, redirect
					action: 'openDeleteModal'
				},

			],
			tableProps: {
				headers: [
                    {
						text: 'Tipo de eventualidad',
						align: 'left',
						value: 'type',
						class: 'table-b-border black--text'
					},
					{
						text: 'Fecha/Periodo',
						align: 'left',
						value: 'date_p',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Comentarios',
						align: 'left',
						value: 'comments',
						class: 'table-b-border black--text comment'
					},
					{
						text: 'Acciones',
						align: 'right',
						sortable: false,
						value: 'actions',
						class: 'table-b-border black--text'
					}
				],
				items: [],
				search: '',
				loading: false
			},

			tableAssignProps:{
				headers: [
                    {
						text: 'Folio',
						align: 'left',
						value: 'id',
						class: 'table-b-border black--text'
					},
					{
						text: 'Descripción',
						align: 'left',
						value: 'description',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Marca',
						align: 'left',
						value: 'brand',
						class: 'table-b-border black--text'
					},
					{
						text: 'No. Serie',
						align: 'left',
						value: 'serial_number',
						class: 'table-b-border black--text'
					},
					{
						text: 'Fecha asignación',
						align: 'left',
						value: 'assignment_date',
						class: 'table-b-border black--text'
					},
				],
				items: [],
				search: '',
				loading: false
			},
            tableVacations:{
                headers: [
                    {
						text: 'Periodo',
						align: 'left',
						value: 'period',
						class: 'table-b-border black--text'
					},
					{
						text: 'Año de Asignación',
						align: 'center',
						value: 'year_number',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Correspondientes',
						align: 'center',
						value: 'vacation_days_available',
						class: 'table-b-border black--text'
					},
					{
						text: 'Por Tomar',
						align: 'center',
						value: 'vacation_days_pending',
						class: 'table-b-border black--text'
					},
					{
						text: 'Acumulados',
						align: 'center',
						value: 'accumulated_days',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Adelantado',
						align: 'center',
						value: 'early_vacations_taken',
						class: 'table-b-border black--text'
					},
                    {
						text: 'expirados',
						align: 'center',
						value: 'expired_days',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Acciones',
						align: 'right',
                        width: '2%',
						sortable: false,
						value: 'actions',
						class: 'table-b-border black--text'
					}
				],
				items: [],
				search: '',
				loading: false
            },
            tableVacationsDetail:{
                headers: [
                    {
						text: 'Fecha',
						align: 'left',
						value: 'period',
						class: 'table-b-border black--text'
					},
					{
						text: 'Días tomados',
						align: 'center',
						value: 'days_taken',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Estatus',
						align: 'center',
						value: 'status',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Acciones',
						align: 'right',
						sortable: false,
						value: 'actions',
						class: 'table-b-border'
					}

				],
				items: [],
				search: '',
				loading: false,
                elevation: '0',
                hideFooter: true,
            },
			modalProps: {
				visible: false,
				width: '500',
				title: 'Eliminar',
				text: '¿Estás seguro de eliminar?',
				loading: false,
				bottomLineColor: 'error',

			},
			modalDocumentsProps: {
				visible: false,
				width: '500',
				title: 'Eliminar',
				text: '¿Estás seguro de eliminar?',
				loading: false,
				bottomLineColor: 'error',

			},
            modalDeleteVacationItemProps: {
				visible: false,
				width: '500',
				title: 'Eliminar',
				text: '¿Estás seguro de eliminar?',
				loading: false,
				bottomLineColor: 'error',

			},
            modalHolidayProps:{
                visible: false,
				width: '700',
				title: 'Detalles del periodo',
				text: '',
				loading: false,
				bottomLineColor: 'primary',

            },
            cancelHolidayModal: {
                text: "Cerrar",
                icon: "",
				to: "",
				block: true,
				color: '',
                click: ()=>{this.modalHolidayProps.visible = false; }
            },

			cancelDeleteVacationItemModal: {
                text: "No, regresar",
                icon: "",
				to: "",
				block: true,
				color: '',
                textColor:'',
                click: ()=>{this.modalDeleteVacationItemProps.visible = false}
            },
            acceptDeleteVacationItemModal: {
                text: "SI, ELIMINAR",
                icon: "",
				to: "",
				block: true,
				color: 'error',
				textColor:'white',
				loading:false,
                click: ()=>{this.deleteVacationItem()}
            },
			cancelModal: {
                text: "No, regresar",
                icon: "",
				to: "",
				block: true,
				color: 'primary',
                textColor:'white',
                click: ()=>{this.modalProps.visible = false}
            },
            cancelDocumentsModal: {
                text: "No, regresar",
                icon: "",
				to: "",
				block: true,
				color: '',
                textColor:'',
                click: ()=>{this.modalDocumentsProps.visible = false}
            },
			acceptModal: {
                text: "SI, ELIMINAR",
                icon: "",
				to: "",
				block: true,
				color: 'error',
				textColor:'white',
				loading:false,
                click: ()=>{this.deleteEvent()}
            },
			acceptDocumentsModal: {
                text: "SI, ELIMINAR",
                icon: "",
				to: "",
				block: true,
				color: 'error',
				textColor:'white',
				loading:false,
                click: ()=>{this.update(true)}
            },
            returnBtnData: {
                text: "<",
                icon: "mdi-chevron-left",

                textClass: "black--text",
				block: false,
                click: ()=> {this.goBack()}
            },

            exportBtnData: {
                text: "Descargar formato impreso",
                icon: "mdi-content-save-outline",
                block:true,
                to: "",
                disabled:false,
                click: () => {this.export()}
            },

		}
	},

	mounted(){
		this.index();
	},

    methods: {
        method_handler(object){
			this[object.method_name](object.parameters)
		},
        goBack()
        {
            if(this.$gates.hasPermission('integradora_user.show')){
                this.$router.push("/e/employees");
                return;
            }
            const urlName = Utils.getLastEmployeePage();
            if(urlName == undefined || urlName == null ){
                this.$router.push('/colaboradores');
                return;
            }
            this.$router.push({name: urlName});
        },
        openPay(url)
        {
            if(url != undefined && url != null && url != "")
                window.open(url)
        },
        getSurveyLayoff()
        {
            this.loadingSurvey = true;
            this.getWeeksPayroll();

            this.$api.employees.getDischargeAnswers(this.id)
                .then((resp) => {
                    //preprocess data
                    this.surveyData = resp.data;

                })
                .catch((error) => {
                    console.log(error)
                })
                .finally(() => {
                    this.loadingSurvey = false;
                })
            ;
        },
        getWeeksPayroll()
        {
            const utils = new Utils();
            // console.log(this.selectedYearPayrolls)
            //actual
            if(this.typeEmployeePayroll == "SEMANAL")
                this.weeksPayroll = utils.weeksYear(this.selectedYearPayrolls);
            else
                this.weeksPayroll = utils.halfMonthsYear(this.selectedYearPayrolls);
            // console.log(this.weeksPayroll);
            // const actual = this.weeksPayroll.filter(w => w.active == true)[0];

            // if(actual != undefined && actual != null && this.selectedWeek == "")
            // {
            //     this.actualWeek = actual.value;
            //     this.selectedWeek = actual.value;
            //     this.index()
            // }
        },

        setPayrollData(inputData)
        {
            this.datesPayload = [];
            //process data
            this.datesPayload.push(
                {
                    quarter: 1,
                    dates:[
                        // {
                        //     dateStart: "2025-01-01",
                        //     dateEnd: "2025-01-15",
                        //     fFileUrl: "", //fiscal
                        //     iFileUrl: "", //integ
                        // }
                    ]
                },
                {
                    quarter: 2,
                    dates:[

                    ]
                },
                {
                    quarter: 3,
                    dates:[

                    ]
                },
                {
                    quarter: 4,
                    dates:[

                    ]
                }
            );

            this.weeksPayroll.forEach(w => {

                //1
                if(parseInt(w.value.split("-")[1]) <= 3){
                    //find quarter
                    const input = inputData.find((itm) => itm.quarter == 1)
                    const fFound = input.records.find((r) => r.start_date == w.value.split("|")[0] && r.end_date == w.value.split("|")[1] && r.type == "FISCAL")
                    const iFound = input.records.find((r) => r.start_date == w.value.split("|")[0] && r.end_date == w.value.split("|")[1] && r.type == "INTEGRADORA")
                    this.datesPayload[0].dates.push({
                        dateStart: w.value.split("|")[0],
                        dateEnd: w.value.split("|")[1],
                        fFileUrl: fFound?.file_url??"", //fiscal
                        iFileUrl: iFound?.file_url??"", //integ
                    })
                    return
                }
                //2
                if(parseInt(w.value.split("-")[1]) <= 6){
                    const input = inputData.find((itm) => itm.quarter == 2)
                    const fFound = input.records.find((r) => r.start_date == w.value.split("|")[0] && r.end_date == w.value.split("|")[1] && r.type == "FISCAL")
                    const iFound = input.records.find((r) => r.start_date == w.value.split("|")[0] && r.end_date == w.value.split("|")[1] && r.type == "INTEGRADORA")
                    this.datesPayload[1].dates.push({
                        dateStart: w.value.split("|")[0],
                        dateEnd: w.value.split("|")[1],
                        fFileUrl: fFound?.file_url??"", //fiscal
                        iFileUrl: iFound?.file_url??"", //integ
                    })
                    return
                }
                //3
                if(parseInt(w.value.split("-")[1]) <= 9){
                    const input = inputData.find((itm) => itm.quarter == 3)
                    const fFound = input.records.find((r) => r.start_date == w.value.split("|")[0] && r.end_date == w.value.split("|")[1] && r.type == "FISCAL")
                    const iFound = input.records.find((r) => r.start_date == w.value.split("|")[0] && r.end_date == w.value.split("|")[1] && r.type == "INTEGRADORA")
                    this.datesPayload[2].dates.push({
                        dateStart: w.value.split("|")[0],
                        dateEnd: w.value.split("|")[1],
                        fFileUrl: fFound?.file_url??"", //fiscal
                        iFileUrl: iFound?.file_url??"", //integ
                    })
                    return
                }
                if(parseInt(w.value.split("-")[1]) <= 12){
                    const input = inputData.find((itm) => itm.quarter == 4)
                    const fFound = input.records.find((r) => r.start_date == w.value.split("|")[0] && r.end_date == w.value.split("|")[1] && r.type == "FISCAL")
                    const iFound = input.records.find((r) => r.start_date == w.value.split("|")[0] && r.end_date == w.value.split("|")[1] && r.type == "INTEGRADORA")
                    this.datesPayload[3].dates.push({
                        dateStart: w.value.split("|")[0],
                        dateEnd: w.value.split("|")[1],
                        fFileUrl: fFound?.file_url??"", //fiscal
                        iFileUrl: iFound?.file_url??"", //integ
                    })
                    return
                }
            });


            this.loadingPayrolls = false;

        },

        loadPayrollDates()
        {
            this.loadingPayrolls = true;
            this.getWeeksPayroll();

            this.$api.payroll.getEmployeePaychecks(this.id, this.selectedYearPayrolls)
                .then((resp) => {
                    //preprocess data
                    let data = [];
                    for (let i = 0; i < resp.data.length; i++) {
                        let item = {
                            quarter: resp.data[i].quarter,
                            start: resp.data[i].start,
                            end: resp.data[i].end,
                            records:[]
                        }
                        for (const [_, value] of Object.entries(resp.data[i].records)) {// eslint-disable-line
                            item.records.push(...value)
                        }
                        //order
                        item.records = item.records.sort((a, b) => a.start_date.localeCompare(b.start_date));
                        data.push(item)
                    }

                    this.setPayrollData(data);

                })
                .catch((error) => {
                    console.log(error)
                })
                .finally(() => {

                })


        },
        getYearSelect()
        {
            this.loadingPayrolls = true;
            this.$api.employees.get(this.id)
				.then((resp) =>{
                    let initialYear = resp.data.current_contract.admission_date.split("-")[0];
                    if(initialYear < 2025)
                        initialYear = 2025
                    this.years = [];
                    let now = new Date();
                    now.setHours(0,0,0,0)
                    const year = now.getFullYear();
                    if(this.selectedYearPayrolls == "")
                        this.selectedYearPayrolls = ""+year;
                    for (let i = initialYear; i <= year; i++) {
                        this.years.push({text: ""+i, value: ""+i});
                    }

                    this.typeEmployeePayroll = resp.data.current_contract.payroll_type


                    this.loadPayrollDates();

				})
				.catch((error) =>{
					console.log(error, "error get employee");
				})
				.finally(() => {
					this.loading = false;

				})
			;


        },
		index(loadingDisable = false) {
            if(this.$gates.hasPermission('integradora_user.show')){
                this.infoLength = 12;
                this.getExternalEmployee(loadingDisable);
                return;
            }
			this.getEmployee(loadingDisable);
		},

        openDeleteDocument(key, miscDoc = false)
        {
            if(miscDoc)
                this.acceptDocumentsModal.click = () => {this.deleteMiscfile(key)}
            else
                this.acceptDocumentsModal.click = () => {this.update(true)}
            this.documentSelected = key;
            this.modalDocumentsProps.visible = true;
        },

        openDeleteDocumentCutBack(key)
        {

            this.acceptDocumentsModal.click = () => {this.updateCutBack(true)}
            this.documentSelected = key;
            this.modalDocumentsProps.visible = true;
        },

        /**
         * Set error messages for documents
        */
        setErrorDocuments(x,message, request){
            x = x.split('.');
            let found = request.documentation[x[1]];
            this.serverErrors[`documentation.${found.type}`] = message;
        },

        setErrorDocumentsCutBack(x,message, request){
            x = x.split('.');
            let found = request.documents[x[1]];
            this.serverErrors[`documentation.${found.type}`] = message;
        },
        /**
         * Set error messages for documents
        */
        setErrorMiscDocuments(x,message){
            x = x.split('.');

            this.serverErrors[`new_employee_files`] = message;
             console.log("si new employe foiles", this.serverErrors)
        },
		/**
		 * Get employee info
		 */
		getEmployee(loadingDisable = false)
		{
            if(!loadingDisable)
                this.loading = true;
			this.$api.employees.get(this.id)
				.then((resp) =>{
					console.log(resp);
                    this.employeeNumber = resp.data.employe_number;
                    this.employeeName = resp.data.name;
					this.employeeText = `${resp.data.employe_number} - ${resp.data.name} - ${Utils.getObjectValue(resp.data,'current_contract.branch_office.company.name')}`

                    this.setFormEmployee(resp);
                    this.setDataEmployee(resp);

                    if(resp.data.status == "INACTIVO")
                        this.showCutBack = true;



				})
				.catch((error) =>{
					console.log(error, "error get employee");
				})
				.finally(() => {
					this.loading = false;

				})
			;
		},

        getExternalEmployee(loadingDisable = false)
		{
            if(!loadingDisable)
                this.loading = true;
			this.$api.externalUser.getEmployee(this.id)
				.then((resp) =>{
					console.log(resp);
                    this.employeeNumber = resp.data.employe_number;
                    this.employeeName = resp.data.name;
					this.employeeText = `${resp.data.employe_number} - ${resp.data.name}`
                    this.setFormEmployee(resp);
                    this.setDataEmployee(resp);
                    this.setExternalUserDocuments(resp?.data?.documents??[]);

                    if(resp.data.status == "INACTIVO")
                        this.showCutBack = true;



				})
				.catch((error) =>{
					console.log(error, "error get employee");
				})
				.finally(() => {
					this.loading = false;

				})
			;
		},

        setExternalUserDocuments(documents)
        {
            this.externalUserDocuments = [];

            const adn = this.getUrlDocument(documents, 'ACTA DE NACIMIENTO');
            this.externalUserDocuments.push(
                {concepto: 'ACTA DE NACIMIENTO', icon: "mdi-eye-outline", index: 'quotation_file_url', valor: adn??"", isFile:adn != undefined && adn != "" ? true:false}
            );

            const ine = this.getUrlDocument(documents, 'IDENTIFICACIÓN OFICIAL');
            this.externalUserDocuments.push(
                {concepto: 'IDENTIFICACIÓN OFICIAL', icon: "mdi-eye-outline", index: 'quotation_file_url', valor: ine??"", isFile:ine != undefined && ine != "" ? true:false}
            );

            const curp = this.getUrlDocument(documents, 'CURP');
            this.externalUserDocuments.push(
                {concepto: 'CURP', icon: "mdi-eye-outline", index: 'quotation_file_url', valor: curp??"", isFile:curp != undefined && curp != "" ? true:false}
            );

            const rfc = this.getUrlDocument(documents, 'RFC');
            this.externalUserDocuments.push(
                {concepto: 'RFC', icon: "mdi-eye-outline", index: 'quotation_file_url', valor: rfc??"", isFile:rfc != undefined && rfc != "" ? true:false}
            );

            const nss = this.getUrlDocument(documents, 'NSS');
            this.externalUserDocuments.push(
                {concepto: 'NSS', icon: "mdi-eye-outline", index: 'quotation_file_url', valor: nss??"", isFile:nss != undefined && nss != "" ? true:false}
            );

            const cdd = this.getUrlDocument(documents, 'COMPROBANTE DE DOMICILIO');
            this.externalUserDocuments.push(
                {concepto: 'COMPROBANTE DE DOMICILIO', icon: "mdi-eye-outline", index: 'quotation_file_url', valor: cdd??"", isFile:cdd != undefined && cdd != "" ? true:false}
            );

            const cv = this.getUrlDocument(documents, 'CURRICULUM VITAE');
            this.externalUserDocuments.push(
                {concepto: 'CURRICULUM VITAE', icon: "mdi-eye-outline", index: 'quotation_file_url', valor: cv??"", isFile: cv != undefined && cv != ""? true:false}
            );


        },

        getCutBackDocuments(loadingDisable = false)
		{
            if(!loadingDisable)
                this.loading = true;
			this.$api.employees.getLeavingDocuments(this.id)
				.then((resp) =>{
					console.log("leavig docs", resp);

                    this.setDocumentsCutBack(resp.data)

				})
				.catch((error) =>{
					console.log(error, "error get employee");
				})
				.finally(() => {
					this.loading = false;

				})
			;
		},

        setFormEmployee(response)
        {
            const payeeAddressData = {
                country: response.data?.country??'',
                zip_code:  response.data?.payee_zip_code??'',
                neighborhood: response.data?.payee_neighborhood??'',
                city: response.data?.payee_city??'',
                state: response.data?.payee_state??'',
            }
            
            this.form = {
                ...this.form,
                employe_number: response.data.employe_number,
                name: response.data.name,
                email: response.data.email,
                business_email: response.data.business_email??"",
                profession: response.data.profession??"",
                birthplace: response.data.birthplace??"",
                birthdate: response.data.birthdate??"",
                gender: response.data.gender??"",
                marital_status: response.data.marital_status??"",
                curp: response.data.curp,
                rfc: response.data.rfc,
                infonavit_number: response.data.infonavit_number??"",
                fonacot_number: response.data.fonacot_number??"",
                nss: response.data.nss,
                phone: response.data.phone,
                blood_type: response.data.blood_type??"",
                diseases: response.data.diseases??[],
                other_diseases: response.data.other_diseases??"",
                country: response.data.country,
                street: response.data.street,
                ext_number: response.data.ext_number??"",
                int_number: response.data.int_number??"",
                zip_code: response.data.zip_code,
                neighborhood: response.data.neighborhood,
                city: response.data.city,
                state: response.data.state,
                emergency_contact: response.data.emergency_contact,
                emergency_number: response.data.emergency_number,
                payee_name: response.data.payee_name??"",
                payee_family_phone: response.data.payee_family_phone??"",
                payee_family_relationship: response.data.payee_family_relationship??"",
                payee_address: response.data?.payee_address??"",
                payee_address_data: payeeAddressData,
                payee_rfc: response.data?.payee_rfc??'',
                payee_curp: response.data?.payee_curp??'',
                photo_file: [],
                photo_url: response.data.photo_url,
                has_childs: false,
                children: [],
                deleteEmployeeFiles: [],
                newEmployeeFiles: [],
            };

            if("children" in response.data){
                if(response.data.children.length > 0){
                    this.form.has_childs = true;

                    response.data.children.forEach(item => {
                        this.form.children.push(
                            {birthdate: item.birthdate, gender: item.gender, id: item.id}
                        )
                    });
                }
            }


            //part 1
            // this.form = {
            //     ...this.form,
            //     photo_file:[],
            //     photo_url: response.data.photo_url,
            //     has_childs: false,
            //     children: []
            // };
            //part 2
            this.setDocuments(response.data.documents);
            this.form.miscFiles = [];
            response.data?.files?.forEach(file => {
                this.form.miscFiles.push({...file, loading:false})
            });
            //part 3
            this.form = {...this.form,
                ...response.data?.current_contract,
                monday_schedule_start: this.getValidTime(response.data?.current_contract?.monday_schedule_start),
                monday_schedule_end: this.getValidTime(response.data?.current_contract?.monday_schedule_end),
                tuesday_schedule_start: this.getValidTime(response.data?.current_contract?.tuesday_schedule_start),
                tuesday_schedule_end: this.getValidTime(response.data?.current_contract?.tuesday_schedule_end),
                wednesday_schedule_start: this.getValidTime(response.data?.current_contract?.wednesday_schedule_start),
                wednesday_schedule_end: this.getValidTime(response.data?.current_contract?.wednesday_schedule_end),
                thursday_schedule_start: this.getValidTime(response.data?.current_contract?.thursday_schedule_start),
                thursday_schedule_end: this.getValidTime(response.data?.current_contract?.thursday_schedule_end),
                friday_schedule_start: this.getValidTime(response.data?.current_contract?.friday_schedule_start),
                friday_schedule_end: this.getValidTime(response.data?.current_contract?.friday_schedule_end),
                saturday_schedule_start: this.getValidTime(response.data?.current_contract?.saturday_schedule_start),
                saturday_schedule_end: this.getValidTime(response.data?.current_contract?.saturday_schedule_end),
                sunday_schedule_start: this.getValidTime(response.data?.current_contract?.sunday_schedule_start),
                sunday_schedule_end: this.getValidTime(response.data?.current_contract?.sunday_schedule_end),
                position_id: response.data?.current_contract?.position?.id,
                branch_office_id: response.data?.current_contract?.branch_office?.id,
                company: (response.data?.current_contract?.branch_office?.company?.id),
                contract_file: [],
                contract_path: response.data?.current_contract?.contract_url??"",
                department_id: response.data.current_contract?.department?.id??"",
                // contract_multifiles: response.data?.current_contract??.files??[],
            };

            this.form.contract_multifiles = response.data?.current_contract?.files.map((item) => {
                let nameFile = item.file.split("/");
                nameFile = nameFile[nameFile.length-1];
                return {url: item.file_url, path: item.file, name: nameFile.replace(/(.{40})..+/, "$1...")}
            });

            console.log(this.form, response.data)

        },

        getValidTime(time)
        {
            if(time == '' || time == null)
                return null;
            return time.substring(0,time.length - 3)
        },

        setDocumentsCutBack(documents)
        {
            //urls
            this.formCutBack.voucher_finiquito_url = this.getUrlDocument(documents, 'COMPROBANTE DE ENTREGA DE FINIQUITO Y/O LIQUIDACIÓN');
            this.formCutBack.voucher_equipment_return_url = this.getUrlDocument(documents, 'VALE ENTREGA DE EQUIPO DE SEGURIDAD Y/O HERRAMIENTA DE TRABAJO');
            this.formCutBack.cutBack_imss_url = this.getUrlDocument(documents, 'COMPROBANTE DE BAJA DEL IMSS');
            this.formCutBack.voucher_computer_return_url = this.getUrlDocument(documents, 'VALE ENTREGA DE LAPTOP Y MOUSE (SIN CONTRASEÑA)');
            this.formCutBack.voucher_phone_return_url = this.getUrlDocument(documents, 'VALE DE ENTREGA DE CELULAR Y/O RADIO');
            this.formCutBack.voucher_removed_sistem_url = this.getUrlDocument(documents, 'COMPROBANTE BAJA EN SISTEMAS OPERACIONALES Y HUELLA DE INGRESO');
            this.formCutBack.voucher_change_email_url = this.getUrlDocument(documents, 'COMPROBANTE DE CAMBIO DE CONTRASEÑA DE CORREO INSTITUCIONAL');

            //doc counts
            let totalReqDoc = 0;
            let countReqDoc = 0;

            for (let i = 0; i < documents.length; i++) {
                const doc = documents[i];
                doc.required = true;
                if(doc.required)
                    totalReqDoc = totalReqDoc + 1;
                if(doc.required && doc.path != null && doc.file_url != null)
                    countReqDoc = countReqDoc + 1;
            }
            this.percReqDocCutBack = ((countReqDoc*100)/totalReqDoc).toFixed(0);

            if (isNaN(this.percReqDocCutBack)) {
                this.percReqDocCutBack = 0
            }

            this.docCutBackTotalsString = `${countReqDoc}/${totalReqDoc} entregados ${this.percReqDocCutBack}%`

        },

        setDocuments(documents){
            //urls
            this.form.birthCertificate_url = this.getUrlDocument(documents, 'ACTA DE NACIMIENTO'); //documents.filter((doc) => doc.type == 'ACTA DE NACIMIENTO')[0].path;
            this.form.ine_url = this.getUrlDocument(documents, 'IDENTIFICACIÓN OFICIAL');//documents.find(doc => doc.type == 'IDENTIFICACIÓN OFICIAL').path;
            this.form.curp_url = this.getUrlDocument(documents, 'CURP');//documents.filter(doc => doc.type == 'CURP')[0].path;
            this.form.rfc_url = this.getUrlDocument(documents, 'RFC'); //documents.filter(doc => doc.type == 'RFC')[0].path;
            this.form.nss_url = this.getUrlDocument(documents, 'NSS'); //documents.filter(doc => doc.type == 'NSS')[0].path;
            this.form.proofResidency_url = this.getUrlDocument(documents, 'COMPROBANTE DE DOMICILIO'); //documents.filter(doc => doc.type == 'COMPROBANTE DE DOMICILIO')[0].path;
            this.form.studyCert_url = this.getUrlDocument(documents, 'CERTIFICADO DE ESTUDIOS'); //documents.filter(doc => doc.type == 'CERTIFICADO DE ESTUDIOS')[0].path;
            this.form.economyStudy_url = this.getUrlDocument(documents, 'ESTUDIO SOCIOECONÓMICO'); //documents.filter(doc => doc.type == 'ESTUDIO SOCIOECONÓMICO')[0].path;
            this.form.recomendationLetter_url = this.getUrlDocument(documents, 'CARTA DE RECOMENDACIÓN'); //documents.filter(doc => doc.type == 'CARTA DE RECOMENDACIÓN')[0].path;
            this.form.psychometricTest_url = this.getUrlDocument(documents, 'PRUEBA PSICOMÉTRICA'); //documents.filter(doc => doc.type == 'PRUEBA PSICOMÉTRICA')[0].path;
            this.form.internalRules_url = this.getUrlDocument(documents,'REGLAMENTO INTERNO'); //documents.filter(doc => doc.type == 'REGLAMENTO INTERNO')[0].path;
            this.form.confidential_url = this.getUrlDocument(documents, 'CONVENCIO CONFIDENCIAL'); //documents.filter(doc => doc.type == 'CONVENCIO CONFIDENCIAL')[0].path;
            this.form.payment_url = this.getUrlDocument(documents, 'PROPUESTA ECONÓMICA'); //documents.filter(doc => doc.type == 'PROPUESTA ECONÓMICA')[0].path;
            this.form.medicalTest_url = this.getUrlDocument(documents, 'EXAMEN MÉDICO');//documents.filter(doc => doc.type == 'EXAMEN MÉDICO')[0].path;
            this.form.letter_url = this.getUrlDocument(documents, 'ANTECEDENTES PENALES'); //documents.filter(doc => doc.type == 'ANTECEDENTES PENALES')[0].path;
            this.form.ret_infonavit_url = this.getUrlDocument(documents, 'AVISO DE RETENCIÓN INFONAVIT'); //documents.filter(doc => doc.type == 'ANTECEDENTES PENALES')[0].path;
            this.form.ret_fonacot_url = this.getUrlDocument(documents, 'AVISO DE RETENCIÓN FONACOT'); //documents.filter(doc => doc.type == 'ANTECEDENTES PENALES')[0].path;
            this.form.epp_url = this.getUrlDocument(documents, 'VALE DE EQUIPO DE PROTECCIÓN PERSONAL'); //documents.filter(doc => doc.type == 'ANTECEDENTES PENALES')[0].path;
            this.form.waiver_equipment_url = this.getUrlDocument(documents, 'CARTA RESPONSIVA DE EQUIPO'); //documents.filter(doc => doc.type == 'ANTECEDENTES PENALES')[0].path;
            this.form.cv_url = this.getUrlDocument(documents, 'CURRICULUM VITAE'); //documents.filter(doc => doc.type == 'ANTECEDENTES PENALES')[0].path;
            this.form.tax_cert_url = this.getUrlDocument(documents, 'CONSTANCIA DE SITUACIÓN FISCAL'); //documents.filter(doc => doc.type == 'ANTECEDENTES PENALES')[0].path;
            this.form.labo_url = this.getUrlDocument(documents, 'LABORATORIOS'); //documents.filter(doc => doc.type == 'ANTECEDENTES PENALES')[0].path;



            //checks
            this.form.birthCertificate_required = this.getRequiredCheckDocument(documents, 'ACTA DE NACIMIENTO'); //documents.filter((doc) => doc.type == 'ACTA DE NACIMIENTO')[0].path;
            this.form.ine_required = this.getRequiredCheckDocument(documents, 'IDENTIFICACIÓN OFICIAL');//documents.find(doc => doc.type == 'IDENTIFICACIÓN OFICIAL').path;
            this.form.curp_required = this.getRequiredCheckDocument(documents, 'CURP');//documents.filter(doc => doc.type == 'CURP')[0].path;
            this.form.rfc_required = this.getRequiredCheckDocument(documents, 'RFC'); //documents.filter(doc => doc.type == 'RFC')[0].path;
            this.form.nss_required = this.getRequiredCheckDocument(documents, 'NSS'); //documents.filter(doc => doc.type == 'NSS')[0].path;
            this.form.proofResidency_required = this.getRequiredCheckDocument(documents, 'COMPROBANTE DE DOMICILIO'); //documents.filter(doc => doc.type == 'COMPROBANTE DE DOMICILIO')[0].path;
            this.form.studyCert_required = this.getRequiredCheckDocument(documents, 'CERTIFICADO DE ESTUDIOS'); //documents.filter(doc => doc.type == 'CERTIFICADO DE ESTUDIOS')[0].path;
            this.form.economyStudy_required = this.getRequiredCheckDocument(documents, 'ESTUDIO SOCIOECONÓMICO'); //documents.filter(doc => doc.type == 'ESTUDIO SOCIOECONÓMICO')[0].path;
            this.form.recomendationLetter_required = this.getRequiredCheckDocument(documents, 'CARTA DE RECOMENDACIÓN'); //documents.filter(doc => doc.type == 'CARTA DE RECOMENDACIÓN')[0].path;
            this.form.psychometricTest_required = this.getRequiredCheckDocument(documents, 'PRUEBA PSICOMÉTRICA'); //documents.filter(doc => doc.type == 'PRUEBA PSICOMÉTRICA')[0].path;
            this.form.internalRules_required = this.getRequiredCheckDocument(documents,'REGLAMENTO INTERNO'); //documents.filter(doc => doc.type == 'REGLAMENTO INTERNO')[0].path;
            this.form.confidential_required = this.getRequiredCheckDocument(documents, 'CONVENCIO CONFIDENCIAL'); //documents.filter(doc => doc.type == 'CONVENCIO CONFIDENCIAL')[0].path;
            this.form.payment_required = this.getRequiredCheckDocument(documents, 'PROPUESTA ECONÓMICA'); //documents.filter(doc => doc.type == 'PROPUESTA ECONÓMICA')[0].path;
            this.form.medicalTest_required = this.getRequiredCheckDocument(documents, 'EXAMEN MÉDICO');//documents.filter(doc => doc.type == 'EXAMEN MÉDICO')[0].path;
            this.form.letter_required = this.getRequiredCheckDocument(documents, 'ANTECEDENTES PENALES'); //documents.filter(doc => doc.type == 'ANTECEDENTES PENALES')[0].path;
            this.form.ret_infonavit_required = this.getRequiredCheckDocument(documents, 'AVISO DE RETENCIÓN INFONAVIT'); //documents.filter(doc => doc.type == 'ANTECEDENTES PENALES')[0].path;
            this.form.ret_fonacot_required = this.getRequiredCheckDocument(documents, 'AVISO DE RETENCIÓN FONACOT'); //documents.filter(doc => doc.type == 'ANTECEDENTES PENALES')[0].path;
            this.form.epp_required = this.getRequiredCheckDocument(documents, 'VALE DE EQUIPO DE PROTECCIÓN PERSONAL'); //documents.filter(doc => doc.type == 'ANTECEDENTES PENALES')[0].path;
            this.form.waiver_equipment_required = this.getRequiredCheckDocument(documents, 'CARTA RESPONSIVA DE EQUIPO'); //documents.filter(doc => doc.type == 'ANTECEDENTES PENALES')[0].path;
            this.form.cv_required = this.getRequiredCheckDocument(documents, 'CURRICULUM VITAE'); //documents.filter(doc => doc.type == 'ANTECEDENTES PENALES')[0].path;
            this.form.tax_cert_required = this.getRequiredCheckDocument(documents, 'CONSTANCIA DE SITUACIÓN FISCAL'); //documents.filter(doc => doc.type == 'ANTECEDENTES PENALES')[0].path;
            this.form.labo_required = this.getRequiredCheckDocument(documents, 'LABORATORIOS'); //documents.filter(doc => doc.type == 'ANTECEDENTES PENALES')[0].path;


            //remove file actions if role is integradora user
            if(this.$gates.hasPermission('integradora_user.show')){
                //permissions
                //required check
                this.form.birthCertificate_showRequired = false;
                this.form.ine_showRequired = false;
                this.form.curp_showRequired = false;
                this.form.rfc_showRequired = false;
                this.form.nss_showRequired = false;
                this.form.proofResidency_showRequired = false;
                this.form.studyCert_showRequired = false;
                this.form.economyStudy_showRequired = false;
                this.form.recomendationLetter_showRequired = false;
                this.form.psychometricTest_showRequired = false;
                this.form.internalRules_showRequired = false;
                this.form.confidential_showRequired = false;
                this.form.payment_showRequired = false;
                this.form.medicalTest_showRequired = false;
                this.form.letter_showRequired = false;
                this.form.ret_infonavit_showRequired = false;
                this.form.ret_fonacot_showRequired = false;
                this.form.epp_showRequired = false;
                this.form.waiver_equipment_showRequired = false;
                this.form.cv_showRequired = false;
                this.form.tax_cert_showRequired = false;
                this.form.labo_showRequired = false;
                //delete
                this.form.birthCertificate_showDelete = false;
                this.form.ine_showDelete = false;
                this.form.curp_showDelete = false;
                this.form.rfc_showDelete = false;
                this.form.nss_showDelete = false;
                this.form.proofResidency_showDelete = false;
                this.form.studyCert_showDelete = false;
                this.form.economyStudy_showDelete = false;
                this.form.recomendationLetter_showDelete = false;
                this.form.psychometricTest_showDelete = false;
                this.form.internalRules_showDelete = false;
                this.form.confidential_showDelete = false;
                this.form.payment_showDelete = false;
                this.form.medicalTest_showDelete = false;
                this.form.letter_showDelete = false;
                this.form.ret_infonavit_showDelete = false;
                this.form.ret_fonacot_showDelete = false;
                this.form.epp_showDelete = false;
                this.form.waiver_equipment_showDelete = false;
                this.form.cv_showDelete = false;
                this.form.tax_cert_showDelete = false;
                this.form.labo_showDelete = false;

            }


            //doc counts
            let totalReqDoc = 0;
            let countReqDoc = 0;

            for (let i = 0; i < documents.length; i++) {
                const doc = documents[i];
                if(doc.required)
                    totalReqDoc = totalReqDoc + 1;
                if(doc.required && doc.path != null && doc.file_url != null)
                    countReqDoc = countReqDoc + 1;
            }
            this.percReqDoc = ((countReqDoc*100)/totalReqDoc).toFixed(0);

            if (isNaN(this.percReqDoc)) {
                this.percReqDoc = 0
            }

            this.docTotalsString = `${countReqDoc}/${totalReqDoc} entregados ${this.percReqDoc}%`

        },

        /**
         * Get document's url by its type
         */
        getUrlDocument(documents, docType){
            try {
                return documents.find(doc => doc.type == docType).file_url;
            } catch (error) {
                return '';
            }
        },
        /**
         * Get document's required check by its type
         */
        getRequiredCheckDocument(documents, docType){
            try {
                return documents.find(doc => doc.type == docType).required == true ? 1 : 0;
            } catch (error) {
                return 0;
            }
        },

        getMiscFileName(stringName)
        {
            const arrName =  stringName.split("/");
            return arrName[arrName.length - 1];
        },

        updateCutBackServer(data){
            let formData = this.prepareRequestCutBack(data);

            const request = Object2Form.objectToFormData(formData,'',[]);
            this.$api.employees.updateLeavingDocuments(this.id, request)
                .then((response) => {
                    this.modalDocumentsProps.visible = false;
                    console.log(response)
                    this.$store.dispatch('snackbarSuccess', `Se ha actualizado correctamente`);

                    this.$refs.formCutBack.reset();
                    this.getCutBackDocuments(true);
                    // await new Promise(r => setTimeout(r, 2000));
                })
                .catch((error) => {
                    //this.setTabErrorByStep(this.step);
                    console.log(error)
                    var errors = []
                    switch(error.response.status){
                        case 400:
                            if(("message" in error.response.data)){
                                // this.setTabErrorByServerMessages(error.response.data.message);
                                Object.keys(error.response.data.message).forEach((x) => {
                                    error.response.data.message[x].forEach((y) => {
                                        if(x.startsWith('documents')){
                                            console.log("documentation start")
                                            this.setErrorDocumentsCutBack(x,y,formData);
                                        }else{
                                            console.log(x,'fuera')
                                            this.serverErrors[x] = Utils.deleteWord(x,y);

                                        }
                                        errors.push(Utils.deleteWord(x,y))
                                    });
                                });
                                this.$store.dispatch('snackbarError', errors.join('.<br>'));
                            }
                        break;

                    }

                    console.log(this.serverErrors);
                })
                .finally(() => {
                //    this.filesLoading[indexfile] = false;
                    this.loadingMiscUpdate = false;
                    this.loadingUpdate = false;
                    this.loadingMiscDelete = false;
                    this.acceptDocumentsModal.loading = false;
                })
            ;
            // eslint-disable-next-line no-console
        },

        updateServer(data)
        {


            let formData = this.prepareRequest(data);

            const request = Object2Form.objectToFormData(formData,'',[]);
            console.log(request)
            this.$api.employees.update('', this.id, request)
                .then((response) => {
                    this.modalDocumentsProps.visible = false;
                    console.log(response)
                    this.$store.dispatch('snackbarSuccess', `Se ha actualizado correctamente`);

                    this.$refs.form.reset();
                    this.index(true);
                    // await new Promise(r => setTimeout(r, 2000));
                })
                .catch((error) => {
                    //this.setTabErrorByStep(this.step);
                    console.log(error)
                    var errors = []
                    switch(error.response.status){
                        case 400:
                            if(("message" in error.response.data)){
                                // this.setTabErrorByServerMessages(error.response.data.message);
                                Object.keys(error.response.data.message).forEach((x) => {
                                    error.response.data.message[x].forEach((y) => {
                                        if(x.startsWith('new_employee_files')){

                                            this.setErrorMiscDocuments(x,y)
                                        }else if(x.startsWith('documentation')){
                                            console.log("documentation start")
                                            this.setErrorDocuments(x,y,formData);
                                        }else{
                                            console.log(x,'fuera')
                                            this.serverErrors[x] = Utils.deleteWord(x,y);

                                        }
                                        errors.push(Utils.deleteWord(x,y))
                                    });
                                });
                                this.$store.dispatch('snackbarError', errors.join('.<br>'));
                            }
                        break;

                    }

                    console.log(this.serverErrors);
                })
                .finally(() => {
                //    this.filesLoading[indexfile] = false;
                    this.loadingMiscUpdate = false;
                    this.loadingUpdate = false;
                    this.loadingMiscDelete = false;
                    this.acceptDocumentsModal.loading = false;
                })
            ;
            // eslint-disable-next-line no-console
        },
        updateMiscFiles()
        {
            if(this.loading || this.loadingUpdate || this.loadingMiscUpdate || this.loadingMiscDelete)
                return;
            if(this.form.newEmployeeFiles.length == 0)
                return;
            this.loadingMiscUpdate = true;
            this.updateServer(this.form)

        },

        updateCutBack(isDelete)
        {
            if(this.loading || this.loadingUpdate || this.loadingMiscUpdate || this.loadingMiscDelete)
                return;
            this.loadingUpdate = true;

            if(isDelete){
                this.acceptDocumentsModal.loading = true;
                this.formCutBack[`${this.documentSelected}`] = "";
            }

            setTimeout(() => {
                this.$refs.returnbtn.$el.focus()
            })

            this.updateCutBackServer(this.formCutBack)
        },

        update(isDelete)
        {
            if(this.loading || this.loadingUpdate || this.loadingMiscUpdate || this.loadingMiscDelete)
                return;
            this.loadingUpdate = true;

            if(isDelete){
                this.acceptDocumentsModal.loading = true;
                this.form[`${this.documentSelected}`] = "";
            }

            setTimeout(() => {
                this.$refs.returnbtn.$el.focus()
            })
            this.form.newEmployeeFiles = [];
            this.updateServer(this.form)
        },

        deleteMiscfile(file)
        {
            if(this.loading || this.loadingUpdate || this.loadingMiscUpdate || this.loadingMiscDelete)
                return;
            this.loadingMiscDelete = true;
            this.acceptDocumentsModal.loading = true;
            console.log("deleteMiscfile called")
            this.form.newEmployeeFiles = [];
            file.loading = true;
            this.form.deleteEmployeeFiles.push(file.file);
            this.updateServer(this.form)
        },

        /**
         * Process data to send
        */
        prepareRequest(data)
        {
            let newData = JSON.parse(JSON.stringify(data));

            delete newData.photo;
            delete newData.documents;

            console.log(data, "data")
            newData.diseases = data.diseases;
            //!Part 1
            //photo_file
            delete newData.photo_file;
            if(data.photo_file instanceof File)
                newData.photo_file = data.photo_file;
            else if(data.photo_url != '')
                newData.photo_path = 'path';


            if(newData.business_email == "")
                delete newData.business_email;

            if(newData.int_number == "")
                delete newData.int_number;

            if(newData.blood_type == "" || newData.blood_type == null)
                delete newData.blood_type;

            if(newData.diseases != null){
                if(newData.diseases.find((item) => item == "OTROS") == undefined)
                    newData.other_diseases = "";
            }

            if(newData.diseases == null || newData.diseases.length == 0)
                delete newData.diseases;

            //payee adress
            newData['payee_state'] = data.payee_address_data.state;
            newData['payee_city'] = data.payee_address_data.city;
            newData['payee_zip_code'] = data.payee_address_data.zip_code;
            newData['payee_neighborhood'] = data.payee_address_data.neighborhood;

            delete newData.payee_address_data;

            //!part 2
            //files
            newData.documentation = [];

            //birthCertificate_file
            delete newData.birthCertificate_file;
            if(data.birthCertificate_file instanceof File)
                newData.documentation.push({file:data.birthCertificate_file, type: 'ACTA DE NACIMIENTO', required: data.birthCertificate_required});
            else if(data.birthCertificate_url != '')
                newData.documentation.push({file_url: "path", type: 'ACTA DE NACIMIENTO', required: data.birthCertificate_required});
            else
                newData.documentation.push({type: 'ACTA DE NACIMIENTO', required: data.birthCertificate_required});

            //ine_file
            delete newData.ine_file;
            if(data.ine_file instanceof File)
                newData.documentation.push({file: data.ine_file, type: 'IDENTIFICACIÓN OFICIAL', required: data.ine_required});
            else if(data.ine_url != '')
                newData.documentation.push({file_url: "path", type: 'IDENTIFICACIÓN OFICIAL', required: data.ine_required});
            else
                newData.documentation.push({type: 'IDENTIFICACIÓN OFICIAL', required: data.ine_required});

            //curp_file
            delete newData.curp_file;
            if(data.curp_file instanceof File)
                newData.documentation.push({file: data.curp_file, type: 'CURP', required: data.curp_required});
            else if(data.curp_url != '')
                newData.documentation.push({file_url: "path", type: 'CURP', required: data.curp_required});
            else
                 newData.documentation.push({type: 'CURP', required: data.curp_required});

            //rfc
            delete newData.rfc_file;
            if(data.rfc_file instanceof File)
                newData.documentation.push({file:data.rfc_file, type: 'RFC', required: data.rfc_required});
            else if(data.rfc_url != '')
                newData.documentation.push({file_url: "path", type: 'RFC', required: data.rfc_required});
            else
                newData.documentation.push({type: 'RFC', required: data.rfc_required});

            //nss_file
            delete newData.nss_file;
            if(data.nss_file instanceof File)
                newData.documentation.push({file: data.nss_file, type:'NSS', required: data.nss_required});
            else if(data.nss_url != '')
                newData.documentation.push({file_url: "path", type:'NSS', required: data.nss_required});
            else
                newData.documentation.push({type:'NSS', required: data.nss_required});


            //proofResidency_file
            delete newData.proofResidency_file;
            if(data.proofResidency_file instanceof File)
                newData.documentation.push({file: data.proofResidency_file, type:'COMPROBANTE DE DOMICILIO', required: data.proofResidency_required});
            else if(data.proofResidency_url != '')
                newData.documentation.push({file_url: "path", type:'COMPROBANTE DE DOMICILIO', required: data.proofResidency_required});
            else
                newData.documentation.push({type:'COMPROBANTE DE DOMICILIO', required: data.proofResidency_required});

            //studyCert_file
            delete newData.studyCert_file;
            if(data.studyCert_file instanceof File)
                newData.documentation.push({file: data.studyCert_file, type:'CERTIFICADO DE ESTUDIOS', required: data.studyCert_required});
            else if(data.studyCert_url != '')
                newData.documentation.push({file_url: "path", type:'CERTIFICADO DE ESTUDIOS', required: data.studyCert_required});
            else
                newData.documentation.push({type:'CERTIFICADO DE ESTUDIOS', required: data.studyCert_required});

            //economyStudy_file
            delete newData.economyStudy_file;
            if(data.economyStudy_file instanceof File)
                newData.documentation.push({file: data.economyStudy_file, type:'ESTUDIO SOCIOECONÓMICO', required: data.economyStudy_required});
            else if(data.economyStudy_url != '')
                newData.documentation.push({file_url: "path", type:'ESTUDIO SOCIOECONÓMICO', required: data.economyStudy_required});
            else
                newData.documentation.push({type:'ESTUDIO SOCIOECONÓMICO', required: data.economyStudy_required});

            //recomendationLetter_file
            delete newData.recomendationLetter_file;
            if(data.recomendationLetter_file instanceof File)
                newData.documentation.push({file: data.recomendationLetter_file, type:'CARTA DE RECOMENDACIÓN', required: data.recomendationLetter_required});
            else if(data.recomendationLetter_url != '')
                newData.documentation.push({file_url: "path", type:'CARTA DE RECOMENDACIÓN', required: data.recomendationLetter_required});
            else
                newData.documentation.push({type:'CARTA DE RECOMENDACIÓN', required: data.recomendationLetter_required});

            //psychometricTest_file
            delete newData.psychometricTest_file;
            if(data.psychometricTest_file instanceof File)
                newData.documentation.push({file: data.psychometricTest_file, type:'PRUEBA PSICOMÉTRICA', required: data.psychometricTest_required});
            else if(data.psychometricTest_url != '')
                newData.documentation.push({file_url: "path", type:'PRUEBA PSICOMÉTRICA', required: data.psychometricTest_required});
            else
                newData.documentation.push({type:'PRUEBA PSICOMÉTRICA', required: data.psychometricTest_required});

            //internalRules_file
            delete newData.internalRules_file;
            if(data.internalRules_file instanceof File)
                newData.documentation.push({file: data.internalRules_file, type:'REGLAMENTO INTERNO', required: data.internalRules_required});
            else if(data.internalRules_url != '')
                newData.documentation.push({file_url: "path", type:'REGLAMENTO INTERNO', required: data.internalRules_required});
            else
                newData.documentation.push({type:'REGLAMENTO INTERNO', required: data.internalRules_required});

            //confidential_file
            delete newData.confidential_file;
            if(data.confidential_file instanceof File)
                newData.documentation.push({file: data.confidential_file, type:'CONVENCIO CONFIDENCIAL', required: data.confidential_required});
            else if(data.confidential_url != '')
                newData.documentation.push({file_url: "path", type:'CONVENCIO CONFIDENCIAL', required: data.confidential_required});
            else
                newData.documentation.push({type:'CONVENCIO CONFIDENCIAL', required: data.confidential_required});

            //payment_file
            delete newData.payment_file;
            if(data.payment_file instanceof File)
                newData.documentation.push({file: data.payment_file, type:'PROPUESTA ECONÓMICA', required: data.payment_required});
            else if(data.payment_url != '')
                newData.documentation.push({file_url: "path", type:'PROPUESTA ECONÓMICA', required: data.payment_required});
            else
                newData.documentation.push({type:'PROPUESTA ECONÓMICA', required: data.payment_required});

            //medicalTest_file
            delete newData.medicalTest_file;
            if(data.medicalTest_file instanceof File)
                newData.documentation.push({file: data.medicalTest_file, type:'EXAMEN MÉDICO', required: data.medicalTest_required});
            else if(data.medicalTest_url != '')
                newData.documentation.push({file_url: "path", type:'EXAMEN MÉDICO', required: data.medicalTest_required});
            else
                newData.documentation.push({type:'EXAMEN MÉDICO', required: data.medicalTest_required});

            //letter_file
            delete newData.letter_file;
            if(data.letter_file instanceof File)
                newData.documentation.push({file: data.letter_file, type:'ANTECEDENTES PENALES', required: data.letter_required});
            else if(data.letter_url != '')
                newData.documentation.push({file_url: "path", type:'ANTECEDENTES PENALES', required: data.letter_required});
            else
                newData.documentation.push({type:'ANTECEDENTES PENALES', required: data.letter_required});

            //ret_infonavit_file
            delete newData.ret_infonavit_file;
            if(data.ret_infonavit_file instanceof File)
                newData.documentation.push({file: data.ret_infonavit_file, type:'AVISO DE RETENCIÓN INFONAVIT', required: data.ret_infonavit_required});
            else if(data.ret_infonavit_url != '')
                newData.documentation.push({file_url: "path", type:'AVISO DE RETENCIÓN INFONAVIT', required: data.ret_infonavit_required});
            else
                newData.documentation.push({type:'AVISO DE RETENCIÓN INFONAVIT', required: data.ret_infonavit_required});


            //ret_fonacot_file
            delete newData.ret_fonacot_file;
            if(data.ret_fonacot_file instanceof File)
                newData.documentation.push({file: data.ret_fonacot_file, type:'AVISO DE RETENCIÓN FONACOT', required: data.ret_fonacot_required});
            else if(data.ret_fonacot_url != '')
                newData.documentation.push({file_url: "path", type:'AVISO DE RETENCIÓN FONACOT', required: data.ret_fonacot_required});
            else
                newData.documentation.push({type:'AVISO DE RETENCIÓN FONACOT', required: data.ret_fonacot_required});


            //epp_file
            delete newData.epp_file;
            if(data.epp_file instanceof File)
                newData.documentation.push({file: data.epp_file, type:'VALE DE EQUIPO DE PROTECCIÓN PERSONAL', required: data.epp_required});
            else if(data.epp_url != '')
                newData.documentation.push({file_url: "path", type:'VALE DE EQUIPO DE PROTECCIÓN PERSONAL', required: data.epp_required});
            else
                newData.documentation.push({type:'VALE DE EQUIPO DE PROTECCIÓN PERSONAL', required: data.epp_required});

            //waiver_equipment_file
            delete newData.waiver_equipment_file;
            if(data.waiver_equipment_file instanceof File)
                newData.documentation.push({file: data.waiver_equipment_file, type:'CARTA RESPONSIVA DE EQUIPO', required: data.waiver_equipment_required});
            else if(data.waiver_equipment_url != '')
                newData.documentation.push({file_url: "path", type:'CARTA RESPONSIVA DE EQUIPO', required: data.waiver_equipment_required});
            else
                newData.documentation.push({type:'CARTA RESPONSIVA DE EQUIPO', required: data.waiver_equipment_required});

            //cv_file
            delete newData.cv_file;
            if(data.cv_file instanceof File)
                newData.documentation.push({file:data.cv_file, type: 'CURRICULUM VITAE', required: data.cv_required});
            else if(data.cv_url != '')
                newData.documentation.push({file_url: "path", type: 'CURRICULUM VITAE', required: data.cv_required});
            else
                newData.documentation.push({type: 'CURRICULUM VITAE', required: data.cv_required});

            //tax_cert_file
            delete newData.tax_cert_file;
            if(data.tax_cert_file instanceof File)
                newData.documentation.push({file:data.tax_cert_file, type: 'CONSTANCIA DE SITUACIÓN FISCAL', required: data.tax_cert_required});
            else if(data.tax_cert_url != '')
                newData.documentation.push({file_url: "path", type: 'CONSTANCIA DE SITUACIÓN FISCAL', required: data.tax_cert_required});
            else
                newData.documentation.push({type: 'CONSTANCIA DE SITUACIÓN FISCAL', required: data.tax_cert_required});

            //labo_file
            delete newData.labo_file;
            if(data.labo_file instanceof File)
                newData.documentation.push({file:data.labo_file, type: 'LABORATORIOS', required: data.labo_required});
            else if(data.labo_url != '')
                newData.documentation.push({file_url: "path", type: 'LABORATORIOS', required: data.labo_required});
            else
                newData.documentation.push({type: 'LABORATORIOS', required: data.labo_required});


            //misc documents
            if(data.newEmployeeFiles.length > 0){
                newData.new_employee_files = [];
                for (let i = 0; i < data.newEmployeeFiles.length; i++) {
                    const element = data.newEmployeeFiles[i];
                    newData.new_employee_files.push({file: element});
                }
            }
            if(data.deleteEmployeeFiles.length > 0){
                newData.delete_employee_files = [];
                for (let i = 0; i < data.deleteEmployeeFiles.length; i++) {
                    const element = data.deleteEmployeeFiles[i];
                    newData.delete_employee_files.push({file_path: element});
                }
            }

            //!part 3
            newData.contract = new Object();
            newData.contract["department_id"] = data.department_id;
            newData.contract["admission_date"] = data.admission_date;
            newData.contract["start_date"] = data.start_date;
            newData.contract["end_date"] = data.end_date;
            newData.contract["type"] = data.type;
            newData.contract["mode"] = data.mode;
            newData.contract["payroll_type"] = data.payroll_type;
            newData.contract["fiscal_salary"] = data.fiscal_salary;
            newData.contract["integrated_salary"] = data.integrated_salary;
            newData.contract["support_transportation"] = data.support_transportation?true:false;
            newData.contract["meal_schedule"] = data.meal_schedule?true:false;
            newData.contract["has_overtime_payment"] = data.has_overtime_payment?true:false;

            if( data.monday_schedule_start != '' &&  data.monday_schedule_start != null)
                newData.contract["monday_schedule_start"] = data.monday_schedule_start;

            if( data.monday_schedule_end != '' &&  data.monday_schedule_end != null)
                newData.contract["monday_schedule_end"] = data.monday_schedule_end;

            if( data.tuesday_schedule_start != '' &&  data.tuesday_schedule_start != null)
                newData.contract["tuesday_schedule_start"] = data.tuesday_schedule_start;

            if( data.tuesday_schedule_end != '' &&  data.tuesday_schedule_end != null)
                newData.contract["tuesday_schedule_end"] = data.tuesday_schedule_end;

            if( data.wednesday_schedule_start != '' &&  data.wednesday_schedule_start != null)
                newData.contract["wednesday_schedule_start"] = data.wednesday_schedule_start;

            if( data.wednesday_schedule_end != '' &&  data.wednesday_schedule_end != null)
                newData.contract["wednesday_schedule_end"] = data.wednesday_schedule_end;

            if( data.thursday_schedule_start != '' &&  data.thursday_schedule_start != null)
                newData.contract["thursday_schedule_start"] = data.thursday_schedule_start;

            if( data.thursday_schedule_end != '' &&  data.thursday_schedule_end != null)
                newData.contract["thursday_schedule_end"] = data.thursday_schedule_end;

            if( data.friday_schedule_start != '' &&  data.friday_schedule_start != null)
                newData.contract["friday_schedule_start"] = data.friday_schedule_start;

            if( data.friday_schedule_end != '' &&  data.friday_schedule_end != null)
                newData.contract["friday_schedule_end"] = data.friday_schedule_end;

            if( data.saturday_schedule_start != '' &&  data.saturday_schedule_start != null)
                newData.contract["saturday_schedule_start"] = data.saturday_schedule_start;
            if( data.saturday_schedule_end != '' &&  data.saturday_schedule_end != null)
                newData.contract["saturday_schedule_end"] = data.saturday_schedule_end;

            if(data.sunday_schedule_start != '' && data.sunday_schedule_start != null)
                newData.contract["sunday_schedule_start"] = data.sunday_schedule_start;
            if(data.sunday_schedule_end != ''&& data.sunday_schedule_end != null)
                newData.contract["sunday_schedule_end"] = data.sunday_schedule_end;

            newData.contract["branch_office_id"] = data.branch_office_id;
            newData.contract["position_id"] = data.position_id;
            newData.contract["repeat_schedule"] = data.repeat_schedule?1:0;

            if(data.type == 'INDETERMINADO'){
                delete newData.contract['start_date'];
                delete newData.contract['end_date'];
            }


            //part 4
            newData.salary = new Object();
            newData.salary["fiscal_salary"] = 
            newData.salary["integrated_salary"] =
            newData.salary["ims_cost"] =
            newData.salary["infonavit_cost"] =
            newData.salary["amortization_infonavit"] =
            newData.salary["isn"] =
            newData.salary["actual_daily_salary"] =
            newData.salary["integration_factor"] =
            newData.salary["daily_fiscal_salary"] = 0;

            if(data.fiscal_salary != '')
                newData.salary["fiscal_salary"] = data.fiscal_salary;
            if(data.integrated_salary)
                newData.salary["integrated_salary"] = data.integrated_salary;
            if(data.ims_cost)
                newData.salary["ims_cost"] = data.ims_cost;
            if(data.infonavit_cost)
                newData.salary["infonavit_cost"] = data.infonavit_cost;
            if(data.amortization_infonavit)
                newData.salary["amortization_infonavit"] = data.amortization_infonavit;
            if(data.isn)
                newData.salary["isn"] = data.isn;
            if(data.actual_daily_salary)
                newData.salary["actual_daily_salary"] = data.actual_daily_salary;
            if(data.integration_factor)
                newData.salary["integration_factor"] = data.integration_factor;
            if(data.daily_fiscal_salary)
                newData.salary["daily_fiscal_salary"] = data.daily_fiscal_salary;

            //contract_file
            delete newData.contract_file;
            // if(data.contract_file instanceof File){
            //     newData.contract["contract_file"] = data.contract_file;
            // }else if(data.contract_path != '')
            //     newData.contract["contract_path"] = data.contract_path;
            // else if(data.contract_path == "")
            //     delete newData.contract["contract_path"];

            //new files
            if(data.contract_file.length > 0){
                newData.contract["new_contract_files"] = data.contract_file.map((item) =>{
                    console.log(item)
                    return {file: item};
                });
            }

            //deleted files
            if(data.delete_contract_files.length > 0){
                newData.contract["delete_contract_files"] = data.delete_contract_files
            }
            delete newData.files;
            delete newData.delete_contract_files;
            delete newData.contract_multifiles;


            delete newData.position;
            delete newData.branch_office;
            delete newData.miscFiles;

            console.log(newData, 99);


            return newData;
        },

        prepareRequestCutBack(data){
            let newData = JSON.parse(JSON.stringify(data));


            //!part 2
            //files
            newData.documents = [];

            //voucher_finiquito_file
            delete newData.voucher_finiquito_file;
            if(data.voucher_finiquito_file instanceof File)
                newData.documents.push({file:data.voucher_finiquito_file, type: 'COMPROBANTE DE ENTREGA DE FINIQUITO Y/O LIQUIDACIÓN'});
            else if(data.voucher_finiquito_url != '')
                newData.documents.push({file_url: "path", type: 'COMPROBANTE DE ENTREGA DE FINIQUITO Y/O LIQUIDACIÓN'});
            else
                newData.documents.push({type: 'COMPROBANTE DE ENTREGA DE FINIQUITO Y/O LIQUIDACIÓN'});

            //voucher_equipment_return_file
            delete newData.voucher_equipment_return_file;
            if(data.voucher_equipment_return_file instanceof File)
                newData.documents.push({file:data.voucher_equipment_return_file, type: 'VALE ENTREGA DE EQUIPO DE SEGURIDAD Y/O HERRAMIENTA DE TRABAJO'});
            else if(data.voucher_equipment_return_url != '')
                newData.documents.push({file_url: "path", type: 'VALE ENTREGA DE EQUIPO DE SEGURIDAD Y/O HERRAMIENTA DE TRABAJO'});
            else
                newData.documents.push({type: 'VALE ENTREGA DE EQUIPO DE SEGURIDAD Y/O HERRAMIENTA DE TRABAJO'});


            //cutBack_imss_file
            delete newData.cutBack_imss_file;
            if(data.cutBack_imss_file instanceof File)
                newData.documents.push({file:data.cutBack_imss_file, type: 'COMPROBANTE DE BAJA DEL IMSS'});
            else if(data.cutBack_imss_url != '')
                newData.documents.push({file_url: "path", type: 'COMPROBANTE DE BAJA DEL IMSS'});
            else
                newData.documents.push({type: 'COMPROBANTE DE BAJA DEL IMSS'});

            //voucher_computer_return_file
            delete newData.voucher_computer_return_file;
            if(data.voucher_computer_return_file instanceof File)
                newData.documents.push({file:data.voucher_computer_return_file, type: 'VALE ENTREGA DE LAPTOP Y MOUSE (SIN CONTRASEÑA)'});
            else if(data.voucher_computer_return_url != '')
                newData.documents.push({file_url: "path", type: 'VALE ENTREGA DE LAPTOP Y MOUSE (SIN CONTRASEÑA)'});
            else
                newData.documents.push({type: 'VALE ENTREGA DE LAPTOP Y MOUSE (SIN CONTRASEÑA)'});


            //voucher_phone_return_file
            delete newData.voucher_phone_return_file;
            if(data.voucher_phone_return_file instanceof File)
                newData.documents.push({file:data.voucher_phone_return_file, type: 'VALE DE ENTREGA DE CELULAR Y/O RADIO'});
            else if(data.voucher_phone_return_url != '')
                newData.documents.push({file_url: "path", type: 'VALE DE ENTREGA DE CELULAR Y/O RADIO'});
            else
                newData.documents.push({type: 'VALE DE ENTREGA DE CELULAR Y/O RADIO'});


            //voucher_removed_sistem_file
            delete newData.voucher_removed_sistem_file;
            if(data.voucher_removed_sistem_file instanceof File)
                newData.documents.push({file:data.voucher_removed_sistem_file, type: 'COMPROBANTE BAJA EN SISTEMAS OPERACIONALES Y HUELLA DE INGRESO'});
            else if(data.voucher_removed_sistem_url != '')
                newData.documents.push({file_url: "path", type: 'COMPROBANTE BAJA EN SISTEMAS OPERACIONALES Y HUELLA DE INGRESO'});
            else
                newData.documents.push({type: 'COMPROBANTE BAJA EN SISTEMAS OPERACIONALES Y HUELLA DE INGRESO'});


            //voucher_change_email_file
            delete newData.voucher_change_email_file;
            if(data.voucher_change_email_file instanceof File)
                newData.documents.push({file:data.voucher_change_email_file, type: 'COMPROBANTE DE CAMBIO DE CONTRASEÑA DE CORREO INSTITUCIONAL'});
            else if(data.voucher_change_email_url != '')
                newData.documents.push({file_url: "path", type: 'COMPROBANTE DE CAMBIO DE CONTRASEÑA DE CORREO INSTITUCIONAL'});
            else
                newData.documents.push({type: 'COMPROBANTE DE CAMBIO DE CONTRASEÑA DE CORREO INSTITUCIONAL'});



            return newData;
        },

        getNeighborhootInfo(neighbothood, type){
            this.loadingCities = true;
            this.loadingStates = true;
            
            this.$locationsApi.locations.getNeighborhoodDetails(neighbothood)
                .then((resp) =>{
                    console.log(resp);

                    if(type == 'EMPLOYEE'){
                        let found = this.generalPersonal.find((x) => x.concepto == 'Colonia');
                        found.valor = resp.data.name;

                        found = this.generalPersonal.find((x) => x.concepto == 'Municipio');
                        found.valor = resp.data.city.name;

                        found = this.generalPersonal.find((x) => x.concepto == 'Estado');
                        found.valor = resp.data.city.state_code;
                        
                    }

                    if(type == 'PAYEE'){
                        let found = this.generalpayee.find((x) => x.concepto == 'Colonia del beneficiario');
                        found.valor = resp.data.name;

                        found = this.generalpayee.find((x) => x.concepto == 'Municipio del beneficiario');
                        found.valor = resp.data.city.name;

                        found = this.generalpayee.find((x) => x.concepto == 'Estado del beneficiario');
                        found.valor = resp.data.city.state_code;
                        
                    }
                    // this.serverItems.cities = [{'value':resp.data.city.id, 'text': resp.data.city.name}];
                    // this.valuesInput.city = resp.data.city.id;
                    // this.valuesInput.state = resp.data.city.state_code == 'CDMX' ? 'DIF' : resp.data.city.state_code;
                })
                .catch((error) =>{
                    console.log(error);
                })
                .finally(() =>{
                    this.loadingCities = false;
                    this.loadingStates = false;
                })
            ;
        },

        isNumberOrDigitsOnlyString(value) {
            // Check if the value is a number
            if (typeof value === 'number' && !isNaN(value)) {
                return true;
            }

            // Check if the value is a string and contains only digits
            if (typeof value === 'string') {
                return /^\d+$/.test(value);
            }

            // If neither, return false
            return false;
        },

        setDataEmployee(resp)
        {
            // { concepto: 'Folio', index: 'id', valor: null },

           

            //position
            this.positionId = resp.data.current_contract?.position?.id;
            //data
            //diseases text
            let distext = '';
            resp.data.diseases?.forEach(br => {
                distext = distext+`${br}\n`;
            });
            //other disease
            distext = distext+`${resp.data.other_diseases??""}\n`;
            resp.data.diseases = distext;
            this.generalPersonal.push(

                {concepto: "Número de colaborador", index: "", valor: resp.data.employe_number,},
                {concepto: "Nombre completo", index: "", valor: resp.data.name,},
                {concepto: "Correo electrónico laboral", index: "", valor: resp.data.business_email??"",},
                {concepto: "Correo electrónico personal", index: "", valor: resp.data.email,},
                {concepto: "Profesión", index: "", valor:resp.data.profession??"", unlessPermission:"integradora_user.show"},
                {concepto: "Lugar de nacimiento", index: "", valor: resp.data.birthplace??"", unlessPermission:"integradora_user.show"},
                {concepto: "Fecha de nacimiento", index: "", valor: Utils.globalDateFormat(resp.data.birthdate??""),},
                {concepto: "Género", index: "", valor: resp.data.gender??"", unlessPermission:"integradora_user.show"},
                {concepto: "Estado civil", index: "", valor: resp.data.marital_status??"", unlessPermission:"integradora_user.show"},
                {concepto: "CURP", index: "", valor: resp.data.curp,},
                {concepto: "RFC", index: "", valor: resp.data.rfc,},
                {concepto: "FONACOT", index: "", valor: resp.data.fonacot_number??"", unlessPermission:"integradora_user.show"},
                {concepto: "INFONAVIT", index: "", valor: resp.data.infonavit_number??"", unlessPermission:"integradora_user.show"},
                {concepto: "NSS", index: "", valor: resp.data.nss,},
                {concepto: "Teléfono", index: "", valor: resp.data.phone, unlessPermission:"integradora_user.show"},
                {concepto: "Tipo de sangre", index: "", valor:resp.data.blood_type??"", unlessPermission:"integradora_user.show"},
                {concepto: "Domicilio", index: "", valor: `${resp.data.street} ${resp.data.ext_number} ${resp.data.int_number}`, unlessPermission:"integradora_user.show" },
                {concepto: "Colonia", index: "", valor: resp.data.neighborhood, unlessPermission:"integradora_user.show"},
                {concepto: "Municipio", index: "", valor: resp.data.city, unlessPermission:"integradora_user.show"},
                {concepto: "Estado", index: "", valor: resp.data.state, unlessPermission:"integradora_user.show"},
                {concepto: "Código postal", index: "", valor: resp.data.zip_code, unlessPermission:"integradora_user.show"},
                {concepto: "Enfermedades crónicas", index: "diseases", valor: resp.data.diseases, unlessPermission:"integradora_user.show"}, //diseases
                {concepto: "Contacto de emergencia", index: "", valor: resp.data.emergency_contact, unlessPermission:"integradora_user.show"},
                {concepto: "Teléfono de emergencia", index: "", valor: resp.data.emergency_number, unlessPermission:"integradora_user.show"},


            );

            //img
            this.employeeImg = resp.data.photo_url??"";




            //payee
            this.generalpayee.push(
                {concepto: "Nombre del beneficiario", index: "", valor: resp.data.payee_name??""},
                {concepto: "Teléfono del beneficiario", index: "", valor: resp.data.payee_family_phone??""},
                {concepto: "Parentesco del beneficiario", index: "", valor: resp.data.payee_family_relationship??""},
                {concepto: "R.F.C. del beneficiario", index: "", valor: resp.data.payee_rfc??""},
                {concepto: "C.U.R.P del beneficiario", index: "", valor: resp.data.payee_curp??""},
                {concepto: "Código postal del beneficiario", index: "", valor: resp.data.payee_zip_code??""},
                {concepto: "Colonia del beneficiario", index: "", valor: resp.data.payee_neighborhood??""},
                {concepto: "Municipio del beneficiario", index: "", valor: resp.data.payee_city??""},
                {concepto: "Estado del beneficiario", index: "", valor: resp.data.payee_state??""},
                {concepto: "Dirección del beneficiario", index: "", valor: resp.data.payee_address??""},
            );

            //children
            this.generalChildren.info.push(
                {concepto: "Cantidad de hijos/hijas", index: "", valor: resp.data.children?.length},
            );
            //push children
            resp.data.children?.forEach(child => {
                let info = [];
                info.push(
                    {concepto: "Fecha de nacimiento", index: "", valor: child.birthdate},
                    {concepto: "Género", index: "", valor: child.gender},
                );
                this.generalChildren.children.push(
                    info
                );
            });


            //employee address
            if(resp.data.country == 'MX')
                this.getNeighborhootInfo(resp.data.neighborhood, 'EMPLOYEE');
            //employee address
            if(this.isNumberOrDigitsOnlyString(resp.data.payee_neighborhood))
                this.getNeighborhootInfo(resp.data.payee_neighborhood, 'PAYEE');


            //part 3
            this.generalContract.push(


                {concepto: "Empresa", index: "", valor: (resp.data.current_contract?.branch_office?.company?.name)},
                {concepto: "Sucursal", index: "", valor: resp.data.current_contract?.branch_office?.name??""},
                {concepto: "Departamento", index: "", valor: resp.data.current_contract?.department?.name??""},
                {concepto: "Fecha de ingreso", index: "", valor: Utils.globalDateFormat(resp.data.current_contract?.admission_date??"")},
                {concepto: "Tipo de contrato", index: "", valor: resp.data.current_contract?.type},
                {concepto: "Modalidad", index: "", valor: resp.data.current_contract?.mode},
                {concepto: "Puesto", index: "", valor: resp.data.current_contract?.position.name},
                {concepto: "Periodicidad de pago", index: "", valor: resp.data.current_contract?.payroll_type},
                {concepto: "Sueldo contratado", index: "", valor: Utils.currencyFormat(resp.data?.signed_salary??0,"")},
                {concepto: "Sueldo fiscal", index: "", valor: Utils.currencyFormat(resp.data?.current_contract?.fiscal_salary??0,"")},
                {concepto: "Sueldo integradora", index: "", valor: Utils.currencyFormat(resp.data?.current_contract?.integrated_salary??0, "")},
                {concepto: "Requiere apoyo para transporte", index: "", valor: resp.data.current_contract?.support_transportation ? "Si":"No"},
                {concepto: "Debe registrar horario de comida", index: "", valor: resp.data.current_contract?.meal_schedule ? "Si": "No"},
                {concepto: "Recibe compensación por horas extra", index: "", valor: resp.data.current_contract?.has_overtime_payment ? "Si": "No"},

            );

            if(resp.data.current_contract?.repeat_schedule){
                this.generalContract.push(
                    {concepto: "Horario", index: "", valor: `L - V ${resp.data.current_contract?.monday_schedule_start} a ${resp.data.current_contract?.monday_schedule_end}`},
                );
            }else{
                this.generalContract.push(
                    {concepto: "Horario lunes", index: "", valor: `${resp.data.current_contract?.monday_schedule_start??'-'} a ${resp.data.current_contract?.monday_schedule_end??'-'}`},
                    {concepto: "Horario martes", index: "", valor: `${resp.data.current_contract?.tuesday_schedule_start??'-'} a ${resp.data.current_contract?.tuesday_schedule_end??'-'}`},
                    {concepto: "Horario miercoles", index: "", valor: `${resp.data.current_contract?.wednesday_schedule_start??'-'} a ${resp.data.current_contract?.wednesday_schedule_end??'-'}`},
                    {concepto: "Horario jueves", index: "", valor: `${resp.data.current_contract?.thursday_schedule_start??'-'} a ${resp.data.current_contract?.thursday_schedule_end??'-'}`},
                    {concepto: "Horario viernes", index: "", valor: `${resp.data.current_contract?.friday_schedule_start??'-'} a ${resp.data.current_contract?.friday_schedule_end??'-'}`},
                );
            }
            if(resp.data.current_contract?.saturday_schedule_start != null){
                this.generalContract.push(
                    {concepto: "Horario sábado", index: "", valor: `${resp.data.current_contract?.saturday_schedule_start} a ${resp.data.current_contract?.saturday_schedule_end}`}
                );
            }
            if(resp.data.current_contract?.sunday_schedule_start != null){
                this.generalContract.push(
                    {concepto: "Horario domingo", index: "", valor: `${resp.data.current_contract?.sunday_schedule_start} a ${resp.data.current_contract?.sunday_schedule_end}`}
                );
            }
            // console.log(resp.data.current_contract??.contract_url)
            // if(resp.data.current_contract??.contract_url != '' && resp.data.current_contract??.contract_url != null){
            //     this.generalContract.push(
            //         {concepto: 'PDF de contratos', index: 'contract_url', valor: resp.data.current_contract??.contract_url??"", isFile:true}
            //     );
            // }else{
            //     this.generalContract.push(
            //         { concepto: 'PDF de contratos', index: 'slug', valor: '' },
            //     );
            // }
            if(resp.data.current_contract?.files != null && resp.data.current_contract?.files.length > 0){
                this.files = resp.data.current_contract?.files.map((item) => {
                    let nameFile = item.file.split("/");
                    nameFile = nameFile[nameFile.length-1];
                    return {url: item.file_url, name:nameFile}
                });
            }


            //part 4
            this.generalSalary.push(
                {concepto: "Sueldo fiscal", index: "", valor: Utils.currencyFormat(resp.data?.current_contract.fiscal_salary??0,"")},
                {concepto: "Sueldo integradora", index: "", valor: Utils.currencyFormat(resp.data?.current_contract.integrated_salary??0,"")},
                {concepto: "Sueldo diario real", index: "", valor: Utils.currencyFormat(resp.data?.current_contract.actual_daily_salary??0,"")},
                {concepto: "Sueldo diario fiscal", index: "", valor: Utils.currencyFormat(resp.data?.current_contract.daily_fiscal_salary??0,"")},
                {concepto: "Factor de integración", index: "", valor: Utils.currencyFormat(resp.data?.current_contract.integration_factor??0,"")},
                {concepto: "Costo IMSS", index: "", valor: Utils.currencyFormat(resp.data?.current_contract.ims_cost??0,"")},
                {concepto: "Costo INFONAVIT", index: "", valor: Utils.currencyFormat(resp.data?.current_contract.infonavit_cost??0,"")},
                {concepto: "Amortización INFONAVIT", index: "", valor: Utils.currencyFormat(resp.data?.current_contract.amortization_infonavit??0,"")},
                {concepto: "Impuestos sobre nómina", index: "", valor: Utils.currencyFormat(resp.data?.current_contract.isn??0,"")},
            );



            //set values for user view

        },


		/**
		 * Load eventualities
		 */
		getEvents()
		{
			if(this.eventsLoaded)
				return;
			this.eventsLoaded = true;
			this.tableProps.loading = true;
			this.$api.eventuality.getFromEmployee(this.id)
				.then((resp) =>{
					this.tableProps.items = resp.data.map((x) => {
						x['actions'] = JSON.parse(JSON.stringify(this.actions))
						// x.actions[0].action = {disabled: true, name: '', params: { id: x.id } };
						x.actions[0].action = {name: 'EmployeeEventEdit', params: {  employee: this.id, eventId:x.id } };
						//x.actions[1].action = {disabled: true, name: '', params: { id: x.id } };
						//console.log(x.actions);

						// if(x.type == 'INASISTENCIAS'){
						// 	x.actions[0].action = { name: 'EmployeeEventEdit', params: {  employee: this.id, eventId:x.id } };
						// 	x.actions[0] = {...x.actions[0], disabled:false};
						// 	// x.actions[1].action = { name: 'EmployeeStatistic', params: { id: x.id } };
						// }


						x.date_p = Utils.globalDateFormat(x.start_date);
						if(x.start_date != x.end_date)
							x.date_p = `${Utils.globalDateFormat(x.start_date)} - ${Utils.globalDateFormat(x.end_date)}`;

						x.comments = Utils.trimStringAt(x.comments, 50);
						x.type = this.changeType(x.type);
						x['parameters'] = { id: x.id, name: `${x.type} - ${x.date_p}`};
						return x
					});
				})
				.catch((error) =>{
					console.log(error, "error statics get employee");
				})
				.finally(() => {
					this.tableProps.loading = false;
				})
			;
		},


		/**
		 * Load business assets
		 */
		getAssets()
		{
			if(this.assetsLoadded)
				return;
			this.assetsLoadded = true;
			this.tableAssignProps.loading = true;
			this.$api.inventory.getFromEmployee(this.id)
				.then((resp) =>{
					this.tableAssignProps.items = resp.data.map((x) => {



                        x.assignment_date = Utils.globalDateFormat(x.assignment_date);
						return x
					});
				})
				.catch((error) =>{
					console.log(error, "error statics get employee");
				})
				.finally(() => {
					this.tableAssignProps.loading = false;
				})
			;
		},

        getHoliday(force = true)
		{
			if(this.holidayLoaded && force)
				return;
			this.tableVacations.items = [];
            this.holidayLoaded = true;
			this.tableVacations.loading = true;

			this.$api.employees.getVacationByEmployee(this.id)
				.then((resp) =>{

                    this.tableVacations.items = resp.data.map((x) => {
                        x['actions'] = JSON.parse(JSON.stringify(this.actionsVacation))

                        try {
                            let per = x.period.split("-");
                            x.period = `${per[2]}/${per[1]}/${per[0]} - ${per[5]}/${per[4]}/${per[3]}`
                        } catch (error) {
                            console.log(error);

                        }
                        x['parameters'] = { id: x.year_number, name: `${x.period}`};

                        x.expired_days??0;

                        return x
					});
				})
				.catch((error) =>{
					console.log(error, "error statics get employee");
				})
				.finally(() => {
					this.tableVacations.loading = false;
				})
			;
		},

		/**
		 * Change eventuality type text
		 */
		changeType(type)
		{
			switch (type) {
				case 'REGISTRAR VACACIONES':
					return 'Vacaciones';

				case 'INCAPACIDADES':
					return 'Incapacidad';

				case 'PERMISOS SIN GOCE':
					return 'Permiso sin goce';

				case 'PERMISOS CON GOCE':
					return 'Permiso con goce';

				case 'INASISTENCIAS':
					return 'Falta';

				case 'DÍAS DE DESCANSO':
					return 'Días de descanso';

				case 'BONOS':
					return 'Bono';

				case 'SUSPENSIONES':
					return 'Suspensión';

				case 'PRÉSTAMOS':
					return 'Préstamo';

				case 'DÍAS EXTRA':
					return 'Días extra';

				case 'PATERNIDAD':
					return 'Paternidad';

				case 'MATERNIDAD':
					return 'Maternidad';

				default:
					return '';
			}
		},

        /**
		 * vacation details modal
        */
        openHolidayDetailModal(parameters)
        {
            this.yearVacationId = parameters.id;
            this.tableVacationsDetail.items = [];
			this.modalHolidayProps = {
				...this.modalHolidayProps,
				title: `Detalles del periodo`,
                text: `Vacaciones correspondientes al año ${parameters.id} de labores`,

			}
            this.modalHolidayProps.visible = true;
			this.loadVacationDetails(parameters);
        },

        loadVacationDetails()
        {
            this.tableVacationsDetail.items = [];
            this.tableVacationsDetail.loading = true;
			this.$api.employees.getVacationEmployeeDetails(this.id, this.yearVacationId)
				.then((resp) =>{
					this.tableVacationsDetail.items = resp.data.map((x) => {
						x['actions'] = JSON.parse(JSON.stringify(this.actionsVacationDetails))


						let year = "";
						x.actions[1].action = { name: 'EmployeeVacationsEdit', params: { id: this.id, vacation_id:  x.id_holiday, } }
                        try {
                            let per = x.period.split("-");
                            year = per[0];
                            x.period = `${per[2]}/${per[1]}/${per[0]} - ${per[5]}/${per[4]}/${per[3]}`
                        } catch (error) {
                            console.log(error);

                        }

						x['parameters'] = { id: x.id_holiday, name: x.period, year:year, yearNumber:this.yearVacationId};


						return x
					});
				})
				.catch((error) =>{
					console.log(error, "error statics get employee");
				})
				.finally(() => {
					this.tableVacationsDetail.loading = false;
				})
			;
        },

        /**
		 * Open modal to delete vacation
        */
		openDeleteVacationModal(parameters){
            // this.modalHolidayProps.visible = false;
            console.log("open", parameters)
			this.vacationId = parameters.id;
			this.modalDeleteVacationItemProps = {
				...this.modalDeleteVacationItemProps,
				text: `¿Estás seguro de eliminar "${parameters.name}"?`,

			}
			this.modalDeleteVacationItemProps.visible = true;
		},

        /**
		 *  delete vacation
        */
        deleteVacationItem()
        {
            this.acceptDeleteVacationItemModal.loading = true;
			this.$api.employees.deleteVacation(this.vacationId)
			// eslint-disable-next-line
			.then((response) => {
				console.log("DELETED");
				this.$store.dispatch('snackbarSuccess', `Se eliminó correctamente`);

				this.getHoliday(false);
				// eslint-disable-next-line
			}).catch(error => {


				this.$store.dispatch('snackbarError', `Error al eliminar. Intenta de nuevo`);
			})
			.finally(() => {
				this.modalDeleteVacationItemProps.visible = false;
				this.acceptDeleteVacationItemModal.loading = false;
                this.modalHolidayProps.visible = false;
			})
        },


        /**
		 * Download vacations pdf
		 */
        pdfVacations(parameters)
        {
            console.log(parameters, "parrrr");
            this.modalHolidayProps.loading = true;
            // this.$store.state.loading = true;
            this.$api.employees.pdfVacations(parameters.id, parameters.yearNumber)
                .then((resp) => {
                    const fileURL = window.URL.createObjectURL(new Blob([resp.data]));
                    const fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute(
                    "download",
                    `${this.employeeName.replace(" ","_").toUpperCase()}_${parameters.year}_${parameters.id}.pdf`
                    );
                    document.body.appendChild(fileLink);
                    fileLink.click();
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.modalHolidayProps.loading = false;
                    // this.$store.state.loading = false;
                })
            ;
        },

		/**
		 * Open modal to delete event
		 */
		openDeleteModal(parameters){
			this.eventId = parameters.id;
			this.modalProps = {
				...this.modalProps,
				text: `¿Estás seguro de eliminar "${parameters.name}"?`,

			}
			this.modalProps.visible = true;
		},



		/**
		 * Delete event
		 */
		deleteEvent(){
			this.acceptModal.loading = true;
			this.$api.eventuality.delete(this.eventId)
			// eslint-disable-next-line
			.then((response) => {

				this.$store.dispatch('snackbarSuccess', `Se eliminó la eventualidad`);
				this.eventsLoaded = false;
				this.getEvents()
				// eslint-disable-next-line
			}).catch(error => {


				this.$store.dispatch('snackbarError', `Error al eliminar. Intenta de nuevo`);
			})
			.finally(() => {
				this.modalProps.visible = false;
				this.acceptModal.loading = false;
			})
		},

        export()
        {
            this.exportBtnData.loading = true;
            this.$store.state.loading = true;
            this.$api.employees.exportEmployeeReport(this.id)
                .then((resp) => {
                    const fileURL = window.URL.createObjectURL(new Blob([resp.data]));
                    const fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute(
                    "download",
                    `employee_report_${this.employeeNumber}.xlsx`
                    );
                    document.body.appendChild(fileLink);
                    fileLink.click();
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.exportBtnData.loading = false;
                    this.$store.state.loading = false;
                })
            ;
        },

        getPosition(position){
            if(position == null || position == "" || position == undefined)
                return;

			//this.$store.state.overlay = true
			this.loadingPosition = true;
			this.$api.positions.get(position)
			.then((response) => {
                this.positionItems.forEach((y) => {
                    y.valor = Utils.getObjectValue(response.data,y.index);
                    if(y.index == 'requires_travel' || y.index == 'requires_english' || y.index == 'have_persons_in_charge')
                        y.valor = y.valor ? 'Si' : 'No';
                });

			})
			.catch(error => {
				console.log(error);
			})
			.finally(() => {
				this.loadingPosition = false;
			})
		},

    }
}
</script>

<style lang="scss">
    .text-col{
        color: var(--v-normalText-base) !important;
    }
    .tab{
		&-header{
			font-size: 0.8125rem !important;
			color: var(--v-normalText-lighten4) !important;
			justify-content: flex-start !important;
			text-transform: unset !important;
		}

		&-active{
			color: var(--v-normalText-base) !important;
		}

		&-error{
			color: var(--v-warning-base) !important;
		}


	}

    .max-width-statics-btn{
        max-width: 390px !important;
    }

    .text-center-web{
        text-align: -webkit-center;
    }


    .documents{

        &-check{
            scale: 1.5;
            padding-top: 6px;
        }
    }


    .statistic-payroll{

        &-header{
            border-bottom: black 2px solid;
            text-align: center;
            font-weight: 700;
            p{
                margin-bottom: 0;
            }

        }

        &-card{
            display: flex;
            align-items: center;


            &-text-cont{
                display: flex;
                justify-content: space-between;
            }
        }
    }


</style>